import React, { useState } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import './SuperMarket.css';

function Boutique() {
  const [categories] = useState({
    
      "Fashion Boutiques": [

      { "name": "Biba Anarkali Kurta Set", "price": 2499 },
  { "name": "W for Woman Printed Skirt", "price": 1799 },
  { "name": "Global Desi Floral Maxi Dress", "price": 2899 },
  { "name": "Libas Cotton Kurti", "price": 1499 },
  { "name": "Aurelia Ethnic Palazzo Set", "price": 1999 },
  { "name": "AND Sleeveless Top", "price": 1299 },
  { "name": "Zink London Wrap Dress", "price": 2199 },
  { "name": "Sakhi Fashions Silk Saree", "price": 3499 },
  { "name": "Pantaloons Printed Tunic", "price": 999 },
  { "name": "Soch Embroidered Kurta", "price": 1899 },

  { "name": "Peter England Formal Shirt", "price": 1399 },
  { "name": "Van Heusen Slim Fit Trousers", "price": 1799 },
  { "name": "Raymond Classic Suit", "price": 5999 },
  { "name": "Allen Solly Casual Shirt", "price": 1299 },
  { "name": "Celio Cotton Chinos", "price": 1699 },
  { "name": "Blackberrys Blazer", "price": 4999 },
  { "name": "Louis Philippe Polo Tee", "price": 999 },
  { "name": "Rex Fashions Printed Shirt", "price": 899 },
  { "name": "Shop M Casual Trousers", "price": 1099 },
  { "name": "Bombay Suiting Formal Pants", "price": 1499 },

  { "name": "MiniKlub Baby Girl Dress", "price": 799 },
  { "name": "Pantaloons Junior Boys Tee", "price": 499 },
  { "name": "Disney Kids Wear Set", "price": 999 },
  { "name": "Little Muffet Lehenga Set", "price": 1599 },
  { "name": "Babycouture Princess Dress", "price": 1299 },
  { "name": "Trendy Toddlers Floral Romper", "price": 899 },
  { "name": "Gini & Jony Boys Shorts", "price": 699 },
  { "name": "Jockey Kids Lounge Set", "price": 1199 },
  { "name": "BIBA Girls Ethnic Dress", "price": 1399 },
  { "name": "Leons Fab Lehenga Choli", "price": 799 },

  { "name": "Cava Sculptor Jacket", "price": 1899 },
  { "name": "Cava Hourglass Leggings", "price": 1499 },
  { "name": "HRX Sports Bra", "price": 999 },
  { "name": "HRX Joggers", "price": 1299 },
  { "name": "Bliss Club High Waist Leggings", "price": 1799 },
  { "name": "Bonkers Ribbed Crop Top", "price": 299 },
  { "name": "Bonkers Workout Shorts", "price": 399 },
  { "name": "Shyaway Racerback Tank", "price": 399 },
  { "name": "Shyaway Padded Sports Bra", "price": 1199 },
  { "name": "Clovia Active Skirt", "price": 798 },

  { "name": "Clovia Camouflage T-shirt", "price": 349 },
  { "name": "Clovia Yoga Dress", "price": 999 },
  { "name": "Shyaway Pleated Skort", "price": 1869 },
  { "name": "Cava Tennis Skorts", "price": 1499 },
  { "name": "Cava Cross Back Bra", "price": 1329 },
  { "name": "Bliss Club Everyday Leggings", "price": 1599 },
  { "name": "HRX Training Tee", "price": 799 },
  { "name": "Decathlon Running Shorts", "price": 699 },
  { "name": "Decathlon Yoga Pants", "price": 999 },
  { "name": "Pantaloons Athleisure Hoodie", "price": 1299 },

  { "name": "Unlimited Fashion Women's Kurti", "price": 999 },
  { "name": "Unlimited Fashion Men's Shirt", "price": 899 },
  { "name": "Unlimited Fashion Kids Set", "price": 799 },
  { "name": "Kalanikethan Silk Saree", "price": 2999 },
  { "name": "Ramraj Cotton Dhoti Set", "price": 1499 },
  { "name": "W for Woman Ethnic Dress", "price": 1899 },
  { "name": "Pantaloons Baby Romper", "price": 599 },
  { "name": "Allen Solly Casual Pants", "price": 1309 },
  { "name": "Pantaloons Junior Ethnic Set", "price": 999 },
  { "name": "Celio Men's Jacket", "price": 2499 },

  { "name": "Pantaloons Women's Co-ord Set", "price": 1699 },
  { "name": "Pantaloons Men's Blazer", "price": 3499 },
  { "name": "Pantaloons Kids Party Dress", "price": 1199 },
  { "name": "Pantaloons Athleisure Joggers", "price": 1099 },
  { "name": "Pantaloons Ethnic Kurta", "price": 1499 },


  { "name": "Janasya Georgette Floral Dress", "price": 1599 },
  { "name": "Soch Schiffli Tunic", "price": 1498 },
  { "name": "Anouk Ethnic Motifs Kurta", "price": 629 },
  { "name": "Rain & Rainbow Cotton Kurti", "price": 798 },
  { "name": "Label Aditi Hundia Short Kurti", "price": 989 },
  { "name": "Nayo Printed Tunic", "price": 679 },
  { "name": "Moda Rapido Puff Sleeve Kurti", "price": 493 },
  { "name": "FERANOID Bandhani Cotton Kurti", "price": 799 },
  { "name": "House of Kari Kashmiri Kurta", "price": 2123 },
  { "name": "Cotton Culture Peach Co-ord Set", "price": 2599 },

  { "name": "Allen Solly Slim Fit Shirt", "price": 899 },
  { "name": "Peter England Ditsy Print Shirt", "price": 899 },
  { "name": "Raymond Checkered Suit", "price": 6499 },
  { "name": "Van Heusen Knit Trousers", "price": 1439 },
  { "name": "Celio Casual Jacket", "price": 2499 },
  { "name": "Blackberrys Formal Blazer", "price": 5299 },
  { "name": "Louis Philippe Stretch Pants", "price": 1599 },
  { "name": "Shop M Printed Shirt", "price": 799 },
  { "name": "Bombay Suiting Cotton Shirt", "price": 1099 },
  { "name": "Rex Fashions Casual Trousers", "price": 1199 },

  { "name": "Little Muffet Lehenga Set", "price": 1599 },
  { "name": "Babycouture Princess Frock", "price": 1299 },
  { "name": "Trendy Toddlers Bunny Hoodie Set", "price": 999 },
  { "name": "Pantaloons Junior Ethnic Set", "price": 999 },
  { "name": "MiniKlub Infant Romper", "price": 599 },
  { "name": "Disney Kids Wear Combo", "price": 999 },
  { "name": "Jockey Kids Lounge Set", "price": 1199 },
  { "name": "Leons Fab Printed Lehenga", "price": 799 },
  { "name": "Gini & Jony Boys Tee", "price": 499 },
  { "name": "Pantaloons Baby Dress", "price": 699 },

  { "name": "Cava Sky-Rise Leggings", "price": 1499 },
  { "name": "Cava Sculptor Jacket", "price": 1899 },
  { "name": "HRX Training Tee", "price": 799 },
  { "name": "HRX Joggers", "price": 1299 },
  { "name": "Bliss Club Everyday Leggings", "price": 1599 },
  { "name": "Bonkers Ribbed Crop Top", "price": 299 },
  { "name": "Bonkers Workout Shorts", "price": 399 },
  { "name": "Shyaway Racerback Tank", "price": 399 },
  { "name": "Shyaway Padded Sports Bra", "price": 1199 },
  { "name": "Clovia Active Skirt", "price": 798 },

  { "name": "Clovia Camouflage T-shirt", "price": 349 },
  { "name": "Clovia Yoga Dress", "price": 999 },
  { "name": "Shyaway Pleated Skort", "price": 1869 },
  { "name": "Cava Tennis Skorts", "price": 1499 },
  { "name": "Cava Cross Back Bra", "price": 1329 },
  { "name": "Bliss Club Flared Leggings", "price": 1799 },
  { "name": "Decathlon Running Shorts", "price": 699 },
  { "name": "Decathlon Yoga Pants", "price": 999 },
  { "name": "Pantaloons Athleisure Hoodie", "price": 1299 },
  { "name": "Pantaloons Joggers", "price": 1099 },

  { "name": "Unlimited Fashion Women's Dress", "price": 999 },
  { "name": "Unlimited Fashion Men's Blazer", "price": 3499 },
  { "name": "Unlimited Fashion Kids Set", "price": 799 },
  { "name": "Kalanikethan Silk Saree", "price": 2999 },
  { "name": "Ramraj Cotton Dhoti Set", "price": 1499 },


  { "name": "Anouk Embroidered Short Kurti", "price": 749 },
  { "name": "Sangria Printed Cotton Tunic", "price": 575 },
  { "name": "Rain & Rainbow Sequinned Kurti", "price": 789 },
  { "name": "Nayam Floral Embroidered Kurti", "price": 781 },
  { "name": "FERANOID Bandhani Printed Kurti", "price": 799 },
  { "name": "Cotton Culture Peach Kurta Set", "price": 2599 },
  { "name": "Soch Tie-Up Neck Tunic", "price": 1498 },
  { "name": "Janasya Blue Georgette Tunic", "price": 987 },
  { "name": "Label Aditi Hundia Elif Kurti", "price": 989 },
  { "name": "Nayo Maroon Printed Tunic", "price": 599 },

  { "name": "Allen Solly Everyday Ditsy Shirt", "price": 899 },
  { "name": "Peter England Slim Fit Shirt", "price": 899 },
  { "name": "Raymond Checkered Suit", "price": 6499 },
  { "name": "Van Heusen Knit Trousers", "price": 1439 },
  { "name": "Celio Casual Jacket", "price": 2499 },
  { "name": "Blackberrys Formal Blazer", "price": 5299 },
  { "name": "Louis Philippe Stretch Pants", "price": 1599 },
  { "name": "Shop M Printed Shirt", "price": 799 },
  { "name": "Bombay Suiting Cotton Shirt", "price": 1099 },
  { "name": "Rex Fashions Casual Trousers", "price": 1199 },

  { "name": "MiniKlub Infant Romper", "price": 599 },
  { "name": "Disney Kids Combo Set", "price": 999 },
  { "name": "Jockey Kids Lounge Set", "price": 1199 },
  { "name": "Leons Fab Printed Lehenga", "price": 799 },
  { "name": "Gini & Jony Boys Tee", "price": 499 },
  { "name": "Pantaloons Baby Dress", "price": 699 },
  { "name": "Little Muffet Floral Lehenga", "price": 1599 },
  { "name": "Babycouture Princess Frock", "price": 1299 },
  { "name": "Trendy Toddlers Bunny Hoodie", "price": 999 },
  { "name": "Pantaloons Junior Ethnic Set", "price": 999 },

  { "name": "Cava Sky-Rise Leggings", "price": 1499 },
  { "name": "Cava Sculptor Jacket", "price": 1899 },
  { "name": "HRX Training Tee", "price": 799 },
  { "name": "HRX Joggers", "price": 1299 },
  { "name": "Bliss Club Everyday Leggings", "price": 1599 },
  { "name": "Bonkers Ribbed Crop Top", "price": 299 },
  { "name": "Bonkers Workout Shorts", "price": 399 },
  { "name": "Shyaway Racerback Tank", "price": 399 },
  { "name": "Shyaway Padded Sports Bra", "price": 1199 },
  { "name": "Clovia Active Skirt", "price": 798 },

  { "name": "Clovia Camouflage T-shirt", "price": 349 },
  { "name": "Clovia Yoga Dress", "price": 999 },
  { "name": "Shyaway Pleated Skort", "price": 1869 },
  { "name": "Cava Tennis Skorts", "price": 1499 },
  { "name": "Cava Cross Back Bra", "price": 1329 },
  { "name": "Bliss Club Flared Leggings", "price": 1799 },
  { "name": "Decathlon Running Shorts", "price": 699 },
  { "name": "Decathlon Yoga Pants", "price": 999 },
  { "name": "Pantaloons Athleisure Hoodie", "price": 1299 },
  { "name": "Pantaloons Joggers", "price": 1099 },

  { "name": "Unlimited Fashion Women's Dress", "price": 999 },
  { "name": "Unlimited Fashion Men's Blazer", "price": 3499 },
  { "name": "Unlimited Fashion Kids Set", "price": 799 },
  { "name": "Kalanikethan Silk Saree", "price": 2999 },
  { "name": "Ramraj Cotton Dhoti Set", "price": 1499 },
  { "name": "Pantaloons Junior Party Dress", "price": 1199 },
  { "name": "Pantaloons Women's Co-ord Set", "price": 1699 },
  { "name": "Pantaloons Men's Blazer", "price": 3499 },
  { "name": "Pantaloons Baby Romper", "price": 599 },
  { "name": "Pantaloons Ethnic Kurta", "price": 1499 },


  { "name": "Anouk Printed Cotton Top", "price": 679 },
  { "name": "Sangria Mandarin Collar Tunic", "price": 575 },
  { "name": "Rain & Rainbow Ethnic Motifs Kurti", "price": 877 },
  { "name": "Label Aditi Hundia Elif Short Kurti", "price": 989 },
  { "name": "Nayo Women Maroon Printed Tunic", "price": 599 },
  { "name": "Soch Floral Print Tunic", "price": 1198 },
  { "name": "Janasya Printed A-Line Tunic", "price": 797 },
  { "name": "FERANOID Bandhani Cotton Kurti", "price": 799 },
  { "name": "House of Kari Kashmiri Kurta", "price": 2123 },
  { "name": "Cotton Culture Co-ord Set", "price": 2599 },

  { "name": "Peter England Ditsy Print Shirt", "price": 899 },
  { "name": "Van Heusen Knit Trousers", "price": 1439 },
  { "name": "Raymond Checkered Suit", "price": 6499 },
  { "name": "Allen Solly Slim Fit Shirt", "price": 899 },
  { "name": "Celio Casual Jacket", "price": 2499 },
  { "name": "Blackberrys Formal Blazer", "price": 5299 },
  { "name": "Louis Philippe Stretch Pants", "price": 1599 },
  { "name": "Shop M Printed Shirt", "price": 799 },
  { "name": "Bombay Suiting Cotton Shirt", "price": 1099 },
  { "name": "Rex Fashions Casual Trousers", "price": 1199 },

  { "name": "MiniKlub Infant Romper", "price": 599 },
  { "name": "Disney Kids Combo Set", "price": 999 },
  { "name": "Jockey Kids Lounge Set", "price": 1199 },
  { "name": "Leons Fab Printed Lehenga", "price": 799 },
  { "name": "Gini & Jony Boys Tee", "price": 499 },
  { "name": "Pantaloons Baby Dress", "price": 699 },
  { "name": "Little Muffet Floral Lehenga", "price": 1599 },
  { "name": "Babycouture Princess Frock", "price": 1299 },
  { "name": "Trendy Toddlers Bunny Hoodie", "price": 999 },
  { "name": "Pantaloons Junior Ethnic Set", "price": 999 },

  { "name": "Cava Sky-Rise Leggings", "price": 1499 },
  { "name": "Cava Sculptor Jacket", "price": 1899 },
  { "name": "HRX Training Tee", "price": 799 },
  { "name": "HRX Joggers", "price": 1299 },
  { "name": "Bliss Club Everyday Leggings", "price": 1599 },
  { "name": "Bonkers Ribbed Crop Top", "price": 299 },
  { "name": "Bonkers Workout Shorts", "price": 399 },
  { "name": "Shyaway Racerback Tank", "price": 399 },
  { "name": "Shyaway Padded Sports Bra", "price": 1199 },
  { "name": "Clovia Active Skirt", "price": 798 },

  { "name": "Clovia Camouflage T-shirt", "price": 349 },
  { "name": "Clovia Yoga Dress", "price": 999 },
  { "name": "Shyaway Pleated Skort", "price": 1869 },
  { "name": "Cava Tennis Skorts", "price": 1499 },
  { "name": "Cava Cross Back Bra", "price": 1329 },
  { "name": "Bliss Club Flared Leggings", "price": 1799 },
  { "name": "Decathlon Running Shorts", "price": 699 },
  { "name": "Decathlon Yoga Pants", "price": 999 },
  { "name": "Pantaloons Athleisure Hoodie", "price": 1299 },
  { "name": "Pantaloons Joggers", "price": 1099 },

  { "name": "Unlimited Fashion Women's Dress", "price": 999 },
  { "name": "Unlimited Fashion Men's Blazer", "price": 3499 },
  { "name": "Unlimited Fashion Kids Set", "price": 799 },
  { "name": "Kalanikethan Silk Saree", "price": 2999 },
  { "name": "Ramraj Cotton Dhoti Set", "price": 1499 },
  { "name": "Pantaloons Junior Party Dress", "price": 1199 },
  { "name": "Pantaloons Women's Co-ord Set", "price": 1699 },
  { "name": "Pantaloons Men's Blazer", "price": 3499 },
  { "name": "Pantaloons Baby Romper", "price": 599 },
  { "name": "Pantaloons Ethnic Kurta", "price": 1499 },


                  ],
                  "Accessories Boutiques": [

      { "name": "Zaveri Pearls Kundan Choker Set", "price": 570 },
  { "name": "Shining Diva Gold Plated Kada", "price": 271 },
  { "name": "YouBella Afghani Tribal Necklace", "price": 449 },
  { "name": "Peora Saree Pins Brooch Set", "price": 199 },
  { "name": "Rubans Temple Jewellery Set", "price": 623 },
  { "name": "Yellow Chimes Drop Earrings Combo", "price": 241 },
  { "name": "Meenaz Bridal Pearl Jhumkas", "price": 330 },
  { "name": "Zaveri Pearls Ethnic Bracelet", "price": 359 },
  { "name": "UrbanLuk Kundan Hairband", "price": 369 },
  { "name": "Shining Diva Pearl Choker Set", "price": 445 },

  { "name": "Kuber Industries Embroidered Clutch", "price": 648 },
  { "name": "Hidesign Leather Clutch", "price": 1799 },
  { "name": "Lavie Mono Wallet", "price": 509 },
  { "name": "Zygma Genuine Leather Purse", "price": 1249 },
  { "name": "Stealodeal PU Leather Clutch", "price": 449 },
  { "name": "Valerie Rhinestone Evening Bag", "price": 499 },
  { "name": "INOVERA Floral Wedding Clutch", "price": 899 },
  { "name": "Accessorize London Red Clutch", "price": 5195 },
  { "name": "Coach Tabby Chain Clutch", "price": 366 },
  { "name": "Tessabit Loewe Flamenco Mini Clutch", "price": 2093 },

  { "name": "Salty Coral Coast Head Scarf", "price": 499 },
  { "name": "Salty Boho Silk Scarf", "price": 499 },
  { "name": "Salty Classic Polka Silk Scarf", "price": 499 },
  { "name": "Salty Chic Orange Silk Scarf", "price": 499 },
  { "name": "StoleVilla Printed Chiffon Scarf", "price": 299 },
  { "name": "Dior Mitzah Zodiac Silk Scarf", "price": 3200 },
  { "name": "Salty Paisley Bandana", "price": 499 },
  { "name": "Salty Noir & Blanc Striped Scarf", "price": 499 },
  { "name": "Salty Summer Polka Dot Scarf", "price": 499 },
  { "name": "Salty Lavender Mist Block Scarf", "price": 499 },

  { "name": "Tommy Hilfiger Textured Belt", "price": 1403 },
  { "name": "Dior Calfskin Belt", "price": 4200 },
  { "name": "Myntra Red Lemon Laptop Bag", "price": 3899 },
  { "name": "Accessorize London Tan Shoulder Bag", "price": 2999 },
  { "name": "Lavie Tara Frame Clutch", "price": 953 },
  { "name": "Urban Forest Tammy Wallet Combo", "price": 899 },
  { "name": "Fostelo Diva Tote Handbag", "price": 663 },
  { "name": "INOVERA Vegan Leather Wallet", "price": 419 },
  { "name": "DailyObjects Zip Wallet", "price": 849 },
  { "name": "SACCI MUCCI Rainbow Sling Bag", "price": 449 },

  { "name": "Tessabit Loewe Flower Sunglasses", "price": 345 },
  { "name": "Tessabit The Attico Satin Clutch", "price": 476 },
  { "name": "Tessabit MM6 Mask Sunglasses", "price": 302 },
  { "name": "Tessabit Alaïa Metal Mask Sunglasses", "price": 471 },
  { "name": "Tessabit Rick Owens Chain Sunglasses", "price": 440 },
  { "name": "Tessabit Victoria Beckham Chain Clutch", "price": 916 },
  { "name": "Tessabit Loewe Slim Sunglasses", "price": 303 },
  { "name": "Tessabit OTTOLINGER Twisted Sunglasses", "price": 314 },
  { "name": "Tessabit COURRÈGES Vision Sunglasses", "price": 330 },
  { "name": "Tessabit TOTEME Classics Sunglasses", "price": 293 },

  { "name": "Dior Silk Mitzah Scarf", "price": 2800 },
  { "name": "Dior Designer Sunglasses", "price": 4100 },
  { "name": "Dior Hair Accessories Set", "price": 3200 },
  { "name": "Dior Wide Brim Hat", "price": 3700 },
  { "name": "Dior Leather Gloves", "price": 2900 },
  { "name": "Dior ABCDior Belt", "price": 4500 },
  { "name": "Dior Silk Shawl", "price": 3900 },
  { "name": "Dior Mitzah Zodiac Wrap", "price": 3100 },
  { "name": "Dior Gold Plated Brooch", "price": 2800 },
  { "name": "Dior Diamond Earrings", "price": 5200 },

  { "name": "Amazon Shining Diva Kada Bracelet", "price": 247 },
  { "name": "Amazon Zaveri Pearls Temple Choker", "price": 446 },
  { "name": "Amazon YouBella Tribal Necklace", "price": 267 },
  { "name": "Amazon Generic Potli Bag Combo", "price": 298 },
  { "name": "Amazon ANNACREATIONS Hair Clip Set", "price": 274 },


  { "name": "Vivanta Multicolor Jewel Set", "price": 176 },
  { "name": "TheSanga Brass Gold-Plated Set", "price": 174 },
  { "name": "Radian Gold-Plated Jewel Set", "price": 269 },
  { "name": "Nagneshi Art Ruby Red Set", "price": 797 },
  { "name": "DENISHA Brass Gold Jewel Set", "price": 267 },
  { "name": "SIDDHI Alloy Gold Jewel Set", "price": 209 },
  { "name": "MODELFLUX White Jewel Set", "price": 159 },
  { "name": "ASMITTA Gold-Plated Necklace", "price": 181 },
  { "name": "RAJASTHANI GAHANA Multicolor Set", "price": 258 },
  { "name": "RD Brothers Multicolor Set", "price": 399 },

  { "name": "ZAVERI PEARLS Temple Choker Set", "price": 446 },
  { "name": "YouBella Tribal Necklace Combo", "price": 449 },
  { "name": "PEORA Juda Pins with Jhumki", "price": 349 },
  { "name": "ACCESSHER Rhinestone Hair Band", "price": 279 },
  { "name": "ANNACREATIONS Flower Hair Clip Set", "price": 221 },
  { "name": "PRETTY PONYTAILS Hair Clip & Ring Set", "price": 459 },
  { "name": "UrbanLuk Mathapatti Hairband", "price": 359 },
  { "name": "A V FASHION Kundan Hair Band", "price": 380 },
  { "name": "Shining Diva Tibetan Necklace", "price": 295 },
  { "name": "ACCESSHER Temple Hair Clip", "price": 329 },

  { "name": "Tessabit Loewe Slim Sunglasses", "price": 303 },
  { "name": "Tessabit OTTOLINGER Twisted Sunglasses", "price": 314 },
  { "name": "Tessabit COURRÈGES Vision Sunglasses", "price": 330 },
  { "name": "Tessabit TOTEME Classics Sunglasses", "price": 293 },
  { "name": "Tessabit Rick Owens Chain Sunglasses", "price": 440 },
  { "name": "Tessabit Alaïa Metal Mask Sunglasses", "price": 471 },
  { "name": "Tessabit MM6 Mask Sunglasses", "price": 302 },
  { "name": "Tessabit The Attico Satin Clutch", "price": 476 },
  { "name": "Tessabit Victoria Beckham Chain Clutch", "price": 916 },
  { "name": "Tessabit Loewe Flower Sunglasses", "price": 345 },

  { "name": "Salty Coral Coast Head Scarf", "price": 499 },
  { "name": "Salty Boho Silk Scarf", "price": 499 },
  { "name": "Salty Classic Polka Silk Scarf", "price": 499 },
  { "name": "Salty Chic Orange Silk Scarf", "price": 499 },
  { "name": "StoleVilla Printed Chiffon Scarf", "price": 299 },
  { "name": "Dior Mitzah Zodiac Silk Scarf", "price": 3200 },
  { "name": "Salty Paisley Bandana", "price": 499 },
  { "name": "Salty Noir & Blanc Striped Scarf", "price": 499 },
  { "name": "Salty Summer Polka Dot Scarf", "price": 499 },
  { "name": "Salty Lavender Mist Block Scarf", "price": 499 },

  { "name": "Dior Wide Brim Hat", "price": 3700 },
  { "name": "Dior Leather Gloves", "price": 2900 },
  { "name": "Dior ABCDior Belt", "price": 4500 },
  { "name": "Dior Silk Shawl", "price": 3900 },
  { "name": "Dior Mitzah Zodiac Wrap", "price": 3100 },
  { "name": "Dior Gold Plated Brooch", "price": 2800 },
  { "name": "Dior Diamond Earrings", "price": 5200 },
  { "name": "Dior Designer Sunglasses", "price": 4100 },
  { "name": "Dior Hair Accessories Set", "price": 3200 },
  { "name": "Dior Silk Mitzah Scarf", "price": 2800 },

  { "name": "Amazon ANNACREATIONS Hair Clip Set", "price": 274 },
  { "name": "Amazon Generic Potli Bag Combo", "price": 298 },
  { "name": "Amazon YouBella Tribal Necklace", "price": 267 },
  { "name": "Amazon Shining Diva Kada Bracelet", "price": 247 },
  { "name": "Amazon Zaveri Pearls Temple Choker", "price": 446 },
  { "name": "Amazon Generic Lehenga Belt", "price": 329 },
  { "name": "Amazon SANNIDHI Pearl Hair Clip", "price": 265 },
  { "name": "Amazon Yellow Chimes Drop Earrings", "price": 241 },
  { "name": "Amazon Meenaz Temple Jhumkas", "price": 330 },
  { "name": "Amazon ACCESSHER Hair Tiara", "price": 279 },

  { "name": "Amazon ANNACREATIONS Flower Hair Clip", "price": 221 },
  { "name": "Amazon UrbanLuk Kundan Hairband", "price": 285 },
  { "name": "Amazon ACCESSHER Peacock Hair Clip", "price": 339 },
  { "name": "Amazon ACCESSHER Diamond Hair Clip", "price": 329 },
  { "name": "Amazon Shining Diva Pearl Choker", "price": 445 },



  { "name": "Vivanta Alloy Gold-Plated Necklace Set", "price": 363 },
  { "name": "Nagneshi Art Ruby Green Necklace", "price": 826 },
  { "name": "SIDDHI Multicolor Jewel Set", "price": 239 },
  { "name": "MODELFLUX White & Gold Necklace", "price": 159 },
  { "name": "ASMITTA Gold-Plated Pendant Set", "price": 181 },
  { "name": "RAJASTHANI GAHANA Multicolor Necklace", "price": 264 },
  { "name": "RD Brothers Ethnic Necklace Set", "price": 399 },
  { "name": "Radian Gold-Plated Beaded Set", "price": 195 },
  { "name": "DENISHA Brass Gold Necklace", "price": 267 },
  { "name": "Swaroop Designer Gold Necklace", "price": 147 },

  { "name": "ZAVERI PEARLS Multistrand Bracelet", "price": 369 },
  { "name": "YouBella Coin Necklace Combo", "price": 329 },
  { "name": "PEORA Juda Pins with Jhumki", "price": 349 },
  { "name": "ACCESSHER Peacock Hair Clip", "price": 339 },
  { "name": "ANNACREATIONS Floral Hair Clip Set", "price": 221 },
  { "name": "PRETTY PONYTAILS Hair Clip & Ring Set", "price": 459 },
  { "name": "UrbanLuk Kundan Hairband", "price": 285 },
  { "name": "A V FASHION Mathapatti Hair Band", "price": 380 },
  { "name": "Shining Diva Tibetan Necklace", "price": 295 },
  { "name": "ACCESSHER Diamond Hair Clip", "price": 329 },

  { "name": "Lavie Mono Wallet", "price": 599 },
  { "name": "Hidesign Leather Clutch", "price": 1799 },
  { "name": "Zygma Genuine Leather Purse", "price": 1249 },
  { "name": "Stealodeal PU Leather Clutch", "price": 449 },
  { "name": "Valerie Rhinestone Evening Bag", "price": 499 },
  { "name": "INOVERA Floral Wedding Clutch", "price": 899 },
  { "name": "Accessorize London Red Clutch", "price": 5195 },
  { "name": "Coach Tabby Chain Clutch", "price": 366 },
  { "name": "Tessabit Loewe Flamenco Mini Clutch", "price": 2093 },
  { "name": "Tessabit Victoria Beckham Chain Clutch", "price": 916 },

  { "name": "Salty Coral Coast Head Scarf", "price": 499 },
  { "name": "Salty Boho Silk Scarf", "price": 499 },
  { "name": "Salty Classic Polka Silk Scarf", "price": 499 },
  { "name": "Salty Chic Orange Silk Scarf", "price": 499 },
  { "name": "StoleVilla Printed Chiffon Scarf", "price": 299 },
  { "name": "Dior Mitzah Zodiac Silk Scarf", "price": 3200 },
  { "name": "Salty Paisley Bandana", "price": 499 },
  { "name": "Salty Noir & Blanc Striped Scarf", "price": 499 },
  { "name": "Salty Summer Polka Dot Scarf", "price": 499 },
  { "name": "Salty Lavender Mist Block Scarf", "price": 499 },

  { "name": "Tommy Hilfiger Textured Belt", "price": 1403 },
  { "name": "Dior Calfskin Belt", "price": 4200 },
  { "name": "Dior ABCDior Belt", "price": 4500 },
  { "name": "Dior Silk Shawl", "price": 3900 },
  { "name": "Dior Wide Brim Hat", "price": 3700 },
  { "name": "Dior Leather Gloves", "price": 2900 },
  { "name": "Dior Gold Plated Brooch", "price": 2800 },
  { "name": "Dior Diamond Earrings", "price": 5200 },
  { "name": "Dior Hair Accessories Set", "price": 3200 },
  { "name": "Dior Silk Mitzah Scarf", "price": 2800 },

  { "name": "Tessabit Loewe Flower Sunglasses", "price": 345 },
  { "name": "Tessabit The Attico Satin Clutch", "price": 476 },
  { "name": "Tessabit MM6 Mask Sunglasses", "price": 302 },
  { "name": "Tessabit Alaïa Metal Mask Sunglasses", "price": 471 },
  { "name": "Tessabit Rick Owens Chain Sunglasses", "price": 440 },
  { "name": "Tessabit OTTOLINGER Twisted Sunglasses", "price": 314 },
  { "name": "Tessabit COURRÈGES Vision Sunglasses", "price": 330 },
  { "name": "Tessabit TOTEME Classics Sunglasses", "price": 293 },
  { "name": "Tessabit LOEWE Slim Sunglasses", "price": 303 },
  { "name": "Tessabit The Attico 8.30 PM Sunglasses", "price": 476 },


  { "name": "Vivanta Gold-Plated Necklace Set", "price": 363 },
  { "name": "Nagneshi Art Ruby Green Necklace", "price": 826 },
  { "name": "SIDDHI Multicolor Jewel Set", "price": 239 },
  { "name": "MODELFLUX White & Gold Necklace", "price": 159 },
  { "name": "ASMITTA Pendant Necklace Set", "price": 181 },
  { "name": "RAJASTHANI GAHANA Ethnic Necklace", "price": 264 },
  { "name": "RD Brothers Designer Necklace Set", "price": 399 },
  { "name": "Radian Beaded Gold-Plated Set", "price": 195 },
  { "name": "DENISHA Brass Necklace Combo", "price": 267 },
  { "name": "Swaroop Designer Gold Necklace", "price": 147 },

  { "name": "ZAVERI PEARLS Multistrand Bracelet", "price": 369 },
  { "name": "YouBella Coin Necklace Combo", "price": 329 },
  { "name": "PEORA Juda Pins with Jhumki", "price": 349 },
  { "name": "ACCESSHER Peacock Hair Clip", "price": 339 },
  { "name": "ANNACREATIONS Floral Hair Clip Set", "price": 221 },
  { "name": "PRETTY PONYTAILS Hair Clip & Ring Set", "price": 459 },
  { "name": "UrbanLuk Kundan Hairband", "price": 285 },
  { "name": "A V FASHION Mathapatti Hair Band", "price": 380 },
  { "name": "Shining Diva Tibetan Necklace", "price": 295 },
  { "name": "ACCESSHER Diamond Hair Clip", "price": 329 },

  { "name": "Lavie Mono Wallet", "price": 599 },
  { "name": "Hidesign Leather Clutch", "price": 1799 },
  { "name": "Zygma Genuine Leather Purse", "price": 1249 },
  { "name": "Stealodeal PU Leather Clutch", "price": 449 },
  { "name": "Valerie Rhinestone Evening Bag", "price": 499 },
  { "name": "INOVERA Floral Wedding Clutch", "price": 899 },
  { "name": "Accessorize London Red Clutch", "price": 5195 },
  { "name": "Coach Tabby Chain Clutch", "price": 366 },
  { "name": "Tessabit Loewe Flamenco Mini Clutch", "price": 2093 },
  { "name": "Victoria Beckham Chain Clutch", "price": 916 },

  { "name": "Salty Coral Coast Head Scarf", "price": 499 },
  { "name": "Salty Boho Silk Scarf", "price": 499 },
  { "name": "Salty Classic Polka Silk Scarf", "price": 499 },
  { "name": "Salty Chic Orange Silk Scarf", "price": 499 },
  { "name": "StoleVilla Printed Chiffon Scarf", "price": 299 },
  { "name": "Dior Mitzah Zodiac Silk Scarf", "price": 3200 },
  { "name": "Salty Paisley Bandana", "price": 499 },
  { "name": "Salty Noir & Blanc Striped Scarf", "price": 499 },
  { "name": "Salty Summer Polka Dot Scarf", "price": 499 },
  { "name": "Salty Lavender Mist Block Scarf", "price": 499 },

  { "name": "Tommy Hilfiger Textured Belt", "price": 1403 },
  { "name": "Dior Calfskin Belt", "price": 4200 },
  { "name": "Dior ABCDior Belt", "price": 4500 },
  { "name": "Dior Silk Shawl", "price": 3900 },
  { "name": "Dior Wide Brim Hat", "price": 3700 },
  { "name": "Dior Leather Gloves", "price": 2900 },
  { "name": "Dior Gold Plated Brooch", "price": 2800 },
  { "name": "Dior Diamond Earrings", "price": 5200 },
  { "name": "Dior Hair Accessories Set", "price": 3200 },
  { "name": "Dior Silk Mitzah Scarf", "price": 2800 },

  { "name": "Loewe Flower Sunglasses", "price": 345 },
  { "name": "The Attico Satin Clutch", "price": 476 },
  { "name": "MM6 Mask Sunglasses", "price": 302 },
  { "name": "Alaïa Metal Mask Sunglasses", "price": 471 },
  { "name": "Rick Owens Chain Sunglasses", "price": 440 },
  { "name": "OTTOLINGER Twisted Sunglasses", "price": 314 },
  { "name": "COURRÈGES Vision Sunglasses", "price": 330 },
  { "name": "TOTEME Classics Sunglasses", "price": 293 },
  { "name": "LOEWE Slim Sunglasses", "price": 303 },
  { "name": "The Attico 8.30 PM Sunglasses", "price": 476 },


                  ],
                  "Footwear Boutiques": [

      { "name": "Bata Women's Flat Kafi Sandal", "price": 314 },
  { "name": "Shoetopia Cross Strap Flat Sandals", "price": 470 },
  { "name": "Mochi Women's Faux Leather Flats", "price": 670 },
  { "name": "YOHO EVA Anti-Skid Sandals", "price": 699 },
  { "name": "Walkaroo Women Casual Sandal", "price": 359 },
  { "name": "Red Tape Casual Sneaker Shoes", "price": 1119 },
  { "name": "Flite Women Slippers", "price": 260 },
  { "name": "Aqualite Women Slippers", "price": 279 },
  { "name": "Picktoes Lightweight Summer Sandals", "price": 348 },
  { "name": "Adda Women Slippers", "price": 492 },

  { "name": "RKSKY Women Heels Sandal", "price": 469 },
  { "name": "Asian Firefly-09 Navy Running Shoes", "price": 830 },
  { "name": "Relaxo Women Slippers", "price": 149 },
  { "name": "Asian Mercury-11 Mint Sports Shoes", "price": 854 },
  { "name": "Shoefly Women Slides", "price": 198 },
  { "name": "Campus OGL-09 Casual Shoes", "price": 1000 },
  { "name": "Asian Casual Sneakers", "price": 914 },
  { "name": "El Paso Women Flats Sandal", "price": 758 },
  { "name": "Shezone Women Heels Sandal", "price": 880 },
  { "name": "Dressberry Premium Bellies", "price": 499 },

  { "name": "Red Tape Athleisure Shoes", "price": 1495 },
  { "name": "Walkaroo Slip-on School Shoes", "price": 322 },
  { "name": "Asian Firefly-04 White Sports Shoes", "price": 866 },
  { "name": "Campus ANNIE Sock-Like Fit Shoes", "price": 1052 },
  { "name": "Zirmer Women Flats Sandal", "price": 199 },
  { "name": "Aqualite Anti-Skid Slides", "price": 270 },
  { "name": "Shoetopia Stylish Sneakers", "price": 924 },
  { "name": "Asian Firefly-10 Navy Training Shoes", "price": 857 },
  { "name": "Shoetopia Women Heels Sandal", "price": 898 },
  { "name": "Asian Firefly-09 Grey Running Shoes", "price": 830 },

  { "name": "Shoetopia Stylish Ankle Wrap Flats", "price": 440 },
  { "name": "Marie Claire VERA TR Slip-on Slippers", "price": 357 },
  { "name": "Shoetopia Women's Block Heel Ballet Flats", "price": 399 },
  { "name": "Shoetopia Stylish Side Buckle Flats", "price": 460 },
  { "name": "Shoetopia Women Flat Sandal", "price": 470 },
  { "name": "Shoetopia Women's Ruhi Heeled Sandal", "price": 463 },
  { "name": "Bata Women's Slip-On Sandal", "price": 546 },
  { "name": "Bata Women's RIVA Sandals", "price": 339 },
  { "name": "Mochi Women Flat Fashion Slip-on", "price": 743 },
  { "name": "Bata Women's Thong Slipper", "price": 460 },

  { "name": "Shoetopia Women's Flat Flats", "price": 399 },
  { "name": "Bata Women's 6715986 Sandal", "price": 779 },
  { "name": "Metro Women's 32-1702 Flat Sandal", "price": 730 },
  { "name": "Shoetopia Shoetopia", "price": 370 },
  { "name": "Doctor Walk Orthopaedic Ballet Flats", "price": 398 },
  { "name": "Shoetopia Stylish Fancy Flat Slipper", "price": 447 },
  { "name": "ZaHu Women Fashion Flat Slippers", "price": 379 },
  { "name": "Bata Women's Debra Toering Flats", "price": 659 },
  { "name": "Shoetopia Women's Heel-1700 Sandal", "price": 499 },
  { "name": "Allen Solly Women's Open Toe Flats", "price": 909 },

  { "name": "Carlton London Cross Strap Comfort Sandals", "price": 967 },
  { "name": "Shoetopia Stylish Ankle Wrap Sandals", "price": 440 },
  { "name": "XE Looks Unique Design Flat Slipper", "price": 447 },
  { "name": "Shoetopia Women's Flat Sandals", "price": 469 },
  { "name": "Mochi Women Fashion Flat Sandal", "price": 777 },
  { "name": "Bata Comfit Women's Slip-on Sandal", "price": 900 },
  { "name": "Bata Comfit Diamonte Backstrap Sandal", "price": 675 },
  { "name": "Bata Comfit Carlene Sandal", "price": 912 },
  { "name": "Bata Comfit Women Flats - Beige", "price": 623 },
  { "name": "Metro Women's Faux Leather Sandals", "price": 729 },

  { "name": "Shoetopia Women's Flat Sandals", "price": 469 },
  { "name": "Bata Women's Slip-On Sandal", "price": 546 },
  { "name": "Shoetopia Women & Girls Flat Sandals", "price": 464 },
  { "name": "Walkaroo WL7554 Trendy Sandals", "price": 378 },
  { "name": "Irsoe Fashionable Flat Slipper", "price": 399} ,


  { "name": "Skechers D'Lites Fashion Sneakers", "price": 3499 },
  { "name": "Nike Air Max Koko Sandals", "price": 8695 },
  { "name": "Adidas Originals Samba OG", "price": 7995 },
  { "name": "Puma Carina Street Sneakers", "price": 4299 },
  { "name": "Reebok Classic Leather Shoes", "price": 4999 },
  { "name": "Crocs Brooklyn Low Wedge Sandals", "price": 3595 },
  { "name": "Catwalk Block Heel Sandals", "price": 1299 },
  { "name": "Metro Faux Leather Heels", "price": 1490 },
  { "name": "Bersache Women Clogs Sandals", "price": 283 },
  { "name": "Dressberry Premium Bellies", "price": 499 },

  { "name": "Roadster Casual Sneakers", "price": 750 },
  { "name": "Lee Cooper Formal Loafers", "price": 1899 },
  { "name": "Sparx Sports Shoes", "price": 999 },
  { "name": "Fila Disruptor II Sneakers", "price": 3999 },
  { "name": "Woodland Leather Boots", "price": 4595 },
  { "name": "Liberty Senorita Sandals", "price": 899 },
  { "name": "Paragon Solea Flats", "price": 299 },
  { "name": "Khadim's Wedge Heels", "price": 799 },
  { "name": "Action Campus Running Shoes", "price": 1199 },
  { "name": "Relaxo Bahamas Flip-Flops", "price": 199 },

  { "name": "ASICS Gel-Excite Sneakers", "price": 5999 },
  { "name": "New Balance 530 Trainers", "price": 6495 },
  { "name": "Converse Chuck Taylor All Star", "price": 3995 },
  { "name": "Birkenstock Arizona Sandals", "price": 4999 },
  { "name": "Dr. Scholl's Comfort Flats", "price": 2299 },
  { "name": "Hush Puppies Leather Loafers", "price": 3499 },
  { "name": "Naturalizer Slingback Heels", "price": 2899 },
  { "name": "Clarks Ankle Boots", "price": 5995 },
  { "name": "Steve Madden Platform Heels", "price": 6995 },
  { "name": "Aldo Strappy Sandals", "price": 5495 },

  { "name": "Bershka Buckled Platform Sandals", "price": 3999 },
  { "name": "New Look Kitten Heel Mules", "price": 2999 },
  { "name": "Glamorous Embroidered Western Boots", "price": 5200 },
  { "name": "ASOS DESIGN Hollow Heeled Sandals", "price": 2600 },
  { "name": "ASOS DESIGN Flavia Espadrille Flats", "price": 2200 },
  { "name": "ASOS DESIGN Foxy Slider Sandals", "price": 1200 },
  { "name": "ASOS DESIGN Cindy Leather Boots", "price": 9500 },
  { "name": "ASOS DESIGN Spicy Slingback Heels", "price": 2800 },
  { "name": "ASOS DESIGN Arley Biker Boots", "price": 4500 },
  { "name": "ASOS DESIGN Flossie Woven Sandals", "price": 1150 },

  { "name": "Nike Air Max Isla Sandals", "price": 8695 },
  { "name": "Nike Dunk Low Sneakers", "price": 9895 },
  { "name": "Nike Cortez Leather Shoes", "price": 10795 },
  { "name": "Nike Pegasus 41 Running Shoes", "price": 11895 },
  { "name": "Nike Air Max Dn8 Sneakers", "price": 17495 },
  { "name": "Nike Calm Elevation Slides", "price": 4695 },
  { "name": "Nike Free Metcon 6 SE Trainers", "price": 11895 },
  { "name": "Nike Structure 26 Running Shoes", "price": 11895 },
  { "name": "Nike Air Max Moto 2K", "price": 11495 },
  { "name": "Nike ReactX Rejuven8 Shoes", "price": 7095 },

  { "name": "Jordan Air 1 Low Retro Sneakers", "price": 8295 },
  { "name": "Jordan Heir Series PF Basketball Shoes", "price": 9695 },
  { "name": "Jordan Air 3 Retro Starfish", "price": 18395 },
  { "name": "Jordan Method of Make Shoes", "price": 12295 },
  { "name": "Jordan Air Max Koko Sandals", "price": 9695 },
  { "name": "Jordan GP Challenge Pro Tennis Shoes", "price": 9695 },
  { "name": "Jordan Air Max Dn8", "price": 17495 },
  { "name": "Jordan Air Max Isla Sandals", "price": 8695 },
  { "name": "Jordan Air Max Moto 2K", "price": 11495 },
  { "name": "Jordan Air Max Koko Sandal SE", "price": 9695 },

  { "name": "Crocs Classic Clog", "price": 3295 },
  { "name": "Skechers Uno - Stand On Air", "price": 5999 },
  { "name": "Adidas Adilette Comfort Slides", "price": 2499 },
  { "name": "Puma Smash v2 Sneakers", "price": 3499 },
  { "name": "Reebok Energen Lite Shoes", "price": 2999 },
  { "name": "Catwalk Metallic Heels", "price": 1399 },
  { "name": "Metro Block Heel Sandals", "price": 1490 },
  { "name": "Liberty Senorita Wedges", "price": 899 },
  { "name": "Paragon Solea Flip-Flops", "price": 299 },
  { "name": "Khadim's Platform Heels", "price": 799 },

  { "name": "ASICS Gel-Contend 8", "price": 5999 },
  { "name": "New Balance Fresh Foam Arishi", "price": 6495 },
  { "name": "Converse Chuck Taylor Lift", "price": 3995 },
  { "name": "Birkenstock Gizeh Sandals", "price": 4999 },
  { "name": "Dr. Scholl's Slip-On Flats", "price": 2299 },
  { "name": "Hush Puppies Ballet Flats", "price": 3499 },
  { "name": "Naturalizer Block Heels", "price": 2899 },
  { "name": "Clarks Desert Boots", "price": 5995 },
  { "name": "Steve Madden Stiletto Heels", "price": 6995 },
  { "name": "Aldo Ankle Strap Sandals", "price": 5495 },

  { "name": "Bershka Platform Sandals", "price": 3999 },
  { "name": "New Look Slingback Mules", "price": 2999 },
  { "name": "Glamorous Western Boots", "price": 5200 },
  { "name": "ASOS DESIGN Espadrille Flats", "price": 2200 },
  { "name": "ASOS DESIGN Slider Sandals", "price": 1200 },
  { "name": "ASOS DESIGN Leather Boots", "price": 9500 },
  { "name": "ASOS DESIGN Slingback Heels", "price": 2800 },
  { "name": "ASOS DESIGN Biker Boots", "price": 4500 },
  { "name": "ASOS DESIGN Woven Sandals", "price": 1150 },
  { "name": "ASOS DESIGN Kitten Heels", "price": 2600 },

  { "name": "Nike Air Max SYSTM", "price": 8695 },
  { "name": "Nike Dunk High Retro", "price": 9895 },
  { "name": "Nike Cortez Basic", "price": 10795 },
  { "name": "Nike Pegasus Trail 4", "price": 11895 },
  { "name": "Nike Air Max 90", "price": 17495 },
  { "name": "Nike Calm Slides", "price": 4695 },
  { "name": "Nike Free Run 5.0", "price": 11895 },
  { "name": "Nike Structure 25", "price": 11895 },
  { "name": "Nike Air Max 270", "price": 11495 },
  { "name": "Nike React Infinity Run", "price": 7095 },

  { "name": "Jordan Air 1 Mid SE", "price": 8295 },
  { "name": "Jordan Zion 3 PF", "price": 9695 },
  { "name": "Jordan Air 3 Retro", "price": 18395 },
  { "name": "Jordan Method of Make", "price": 12295 },
  { "name": "Jordan Max Aura 5", "price": 9695 },
  { "name": "Jordan GP Challenge Pro", "price": 9695 },
  { "name": "Jordan Air Max 90", "price": 17495 },
  { "name": "Jordan Air Max Isla", "price": 8695 },
  { "name": "Jordan Air Max 270", "price": 11495 },
  { "name": "Jordan Koko Sandal SE", "price": 9695 },

  { "name": "Fila Ray Tracer Sneakers", "price": 3999 },
  { "name": "Woodland Trekking Boots", "price": 4595 },
  { "name": "Lee Cooper Slip-On Loafers", "price": 1899 },
  { "name": "Sparx Running Shoes", "price": 999 },
  { "name": "Liberty Senorita Heels", "price": 899 },



  { "name": "Christian Louboutin So Kate Stiletto Heels", "price": 78995 },
  { "name": "Jimmy Choo Romy 100 Glitter Pumps", "price": 68995 },
  { "name": "Gucci GG Marmont Leather Sandals", "price": 59995 },
  { "name": "Prada Monolith Combat Boots", "price": 84995 },
  { "name": "Balenciaga Triple S Sneakers", "price": 79995 },
  { "name": "Saint Laurent Tribute Platform Sandals", "price": 72995 },
  { "name": "Alexander McQueen Oversized Sneakers", "price": 69995 },
  { "name": "Chanel Quilted Leather Boots", "price": 89995 },
  { "name": "Dior D-Connect Sneakers", "price": 75995 },
  { "name": "Versace Medusa Chain Sandals", "price": 64995 },

  { "name": "Steve Madden Vala Pointed Toe Heels", "price": 6995 },
  { "name": "Aldo Stessy Stiletto Pumps", "price": 5995 },
  { "name": "Charles & Keith Ankle Strap Heels", "price": 4995 },
  { "name": "H&M Faux Suede Block Heels", "price": 2299 },
  { "name": "Zara Metallic High Heel Sandals", "price": 3999 },
  { "name": "Forever 21 Platform Heels", "price": 2899 },
  { "name": "Bershka Buckled Sandals", "price": 3499 },
  { "name": "New Look Kitten Heel Mules", "price": 2999 },
  { "name": "Glamorous Embroidered Western Boots", "price": 5200 },
  { "name": "ASOS DESIGN Hollow Heeled Sandals", "price": 2600 },

  { "name": "Nike Air Max 270 React", "price": 11495 },
  { "name": "Adidas Ultraboost 23", "price": 13995 },
  { "name": "Puma RS-X Reinvention", "price": 7995 },
  { "name": "Reebok Zig Kinetica II", "price": 8995 },
  { "name": "New Balance 9060", "price": 16000 },
  { "name": "Fila Ray Tracer", "price": 3999 },
  { "name": "ASICS Gel-Nimbus 26", "price": 12995 },
  { "name": "Converse Chuck 70 High Tops", "price": 5995 },
  { "name": "Jordan Air 1 Low", "price": 8295 },
  { "name": "Under Armour HOVR Phantom 3", "price": 9995 },

  { "name": "Birkenstock Arizona EVA Sandals", "price": 4999 },
  { "name": "Crocs Classic Crush Sandals", "price": 3295 },
  { "name": "Dr. Martens Blaire Quad Sandals", "price": 8495 },
  { "name": "Clarks Un Rio Strap Sandals", "price": 6995 },
  { "name": "Naturalizer Vera Heels", "price": 2899 },
  { "name": "Hush Puppies Slingback Flats", "price": 3499 },
  { "name": "Liberty Senorita Wedges", "price": 899 },
  { "name": "Paragon Solea Flip-Flops", "price": 299 },
  { "name": "Khadim's Platform Heels", "price": 799 },
  { "name": "Relaxo Bahamas Flip-Flops", "price": 199 },

  { "name": "Bata Comfit Diamonte Sandals", "price": 675 },
  { "name": "Mochi Faux Leather Flats", "price": 670 },
  { "name": "Shoetopia Ankle Wrap Flats", "price": 440 },
  { "name": "Walkaroo Casual Sandals", "price": 359 },
  { "name": "YOHO EVA Anti-Skid Sandals", "price": 699 },
  { "name": "Flite Women Slippers", "price": 260 },
  { "name": "Aqualite Women Slippers", "price": 279 },
  { "name": "Picktoes Summer Sandals", "price": 348 },
  { "name": "Adda Women Slippers", "price": 492 },
  { "name": "Marie Claire Slip-on Slippers", "price": 357 },

  { "name": "Allen Solly Open Toe Flats", "price": 909 },
  { "name": "Carlton London Cross Strap Sandals", "price": 967 },
  { "name": "Metro Faux Leather Sandals", "price": 729 },
  { "name": "Doctor Walk Orthopaedic Flats", "price": 398 },
  { "name": "ZaHu Fashion Flat Slippers", "price": 379 },
  { "name": "Irsoe Flat Slippers", "price": 399 },
  { "name": "XE Looks Fancy Flat Slippers", "price": 447 },
  { "name": "Shezone Heels Sandal", "price": 880 },
  { "name": "El Paso Flats Sandal", "price": 758 },
  { "name": "Asian Firefly-09 Running Shoes", "price": 830 },


                  ],
                  "Beauty & Cosmetic Boutiques": [

    { "name": "La Mer Crème de la Mer Moisturizer 60ml", "price": 26500 },
  { "name": "Estée Lauder Advanced Night Repair Serum 50ml", "price": 9900 },
  { "name": "Chanel Sublimage L’Essence Ultimate Skin Regeneration", "price": 21500 },
  { "name": "Dior Capture Totale Super Potent Serum 50ml", "price": 12500 },
  { "name": "SK-II Facial Treatment Essence 230ml", "price": 18900 },
  { "name": "Lancôme Absolue Soft Cream 60ml", "price": 18500 },
  { "name": "Dr. Barbara Sturm Hyaluronic Serum 30ml", "price": 24500 },
  { "name": "Tatcha The Dewy Skin Cream 50ml", "price": 7800 },
  { "name": "Augustinus Bader The Rich Cream 50ml", "price": 21500 },
  { "name": "Sisley Paris Black Rose Cream Mask 60ml", "price": 13500 },

  { "name": "Charlotte Tilbury Airbrush Flawless Foundation", "price": 4200 },
  { "name": "M.A.C Studio Fix Fluid SPF 15", "price": 3600 },
  { "name": "Bobbi Brown Skin Long-Wear Weightless Foundation", "price": 4800 },
  { "name": "Guerlain L’Essentiel Natural Glow Foundation", "price": 5900 },
  { "name": "YSL Touche Éclat Radiant Touch Concealer", "price": 3900 },
  { "name": "Tom Ford Shade and Illuminate Duo", "price": 8900 },
  { "name": "Hourglass Ambient Lighting Palette", "price": 7200 },
  { "name": "By Terry Hyaluronic Hydra-Powder", "price": 5200 },
  { "name": "Huda Beauty FauxFilter Foundation", "price": 3990 },
  { "name": "Pat McGrath Labs Sublime Perfection Foundation", "price": 7200 },

  { "name": "Jo Malone London Peony & Blush Suede Cologne 100ml", "price": 11800 },
  { "name": "Tom Ford Black Orchid Eau de Parfum 100ml", "price": 14500 },
  { "name": "Maison Francis Kurkdjian Baccarat Rouge 540 70ml", "price": 28500 },
  { "name": "Creed Aventus Eau de Parfum 100ml", "price": 32500 },
  { "name": "Chanel No. 5 Eau de Parfum 100ml", "price": 12500 },
  { "name": "Dior Sauvage Elixir 100ml", "price": 13500 },
  { "name": "Hermès Twilly d’Hermès Eau Poivrée 85ml", "price": 9800 },
  { "name": "Gucci Bloom Eau de Parfum 100ml", "price": 10500 },
  { "name": "YSL Libre Eau de Parfum 90ml", "price": 11200 },
  { "name": "Valentino Donna Born In Roma 100ml", "price": 10900 },

  { "name": "Moroccanoil Treatment Original 100ml", "price": 3700 },
  { "name": "Kerastase Elixir Ultime Oil 100ml", "price": 4200 },
  { "name": "Olaplex No.3 Hair Perfector 100ml", "price": 3200 },
  { "name": "Briogeo Don’t Despair, Repair! Deep Conditioning Mask", "price": 3900 },
  { "name": "Oribe Gold Lust Repair & Restore Shampoo 250ml", "price": 5200 },
  { "name": "Aveda Damage Remedy Daily Hair Repair 100ml", "price": 3400 },
  { "name": "Philip Kingsley Elasticizer Deep-Conditioning Treatment", "price": 4600 },
  { "name": "Living Proof Perfect Hair Day Dry Shampoo", "price": 2800 },
  { "name": "OUAI Hair Oil 45ml", "price": 3200 },
  { "name": "Christophe Robin Regenerating Mask with Prickly Pear Oil", "price": 5600 },

  { "name": "Forest Essentials Soundarya Radiance Cream", "price": 5950 },
  { "name": "Kama Ayurveda Kumkumadi Miraculous Beauty Fluid", "price": 2850 },
  { "name": "Plum Green Tea Alcohol-Free Toner", "price": 390 },
  { "name": "Just Herbs Ayurvedic Lipstick Kit", "price": 1295 },
  { "name": "Juicy Chemistry Organic Rosehip Oil", "price": 950 },
  { "name": "SoulTree Ayurvedic Kajal", "price": 895 },
  { "name": "Biotique Bio Morning Nectar Moisturizer", "price": 280 },
  { "name": "Mamaearth Vitamin C Face Serum", "price": 599 },
  { "name": "WOW Skin Science Apple Cider Vinegar Shampoo", "price": 499 },
  { "name": "The Moms Co. Natural Vita Rich Face Cream", "price": 699 },

  { "name": "Clinique Moisture Surge 100H Auto-Replenishing Hydrator", "price": 4200 },
  { "name": "The Body Shop Drops of Youth Concentrate", "price": 2995 },
  { "name": "L'Occitane Immortelle Divine Cream", "price": 7200 },
  { "name": "Laneige Water Sleeping Mask", "price": 2200 },
  { "name": "Innisfree Green Tea Seed Serum", "price": 2150 },
  { "name": "Kiehl’s Ultra Facial Cream", "price": 2950 },
  { "name": "Shiseido Ultimune Power Infusing Concentrate", "price": 8500 },
  { "name": "Pixi Glow Tonic", "price": 1450 },
  { "name": "COSRX Advanced Snail 96 Mucin Power Essence", "price": 1850 },
  { "name": "Drunk Elephant C-Firma Fresh Day Serum", "price": 7200 },


  { "name": "La Prairie Skin Caviar Luxe Cream 50ml", "price": 29500 },
  { "name": "Guerlain Orchidée Impériale Cream 50ml", "price": 26500 },
  { "name": "Clé de Peau Beauté The Serum 50ml", "price": 28500 },
  { "name": "Valmont Prime Renewing Pack 50ml", "price": 21500 },
  { "name": "Omorovicza Blue Diamond Supercream 50ml", "price": 24500 },
  { "name": "111SKIN Celestial Black Diamond Cream 50ml", "price": 27500 },
  { "name": "RéVive Intensité Crème Lustre Night 50ml", "price": 25900 },
  { "name": "Chantecaille Bio Lifting Mask 50ml", "price": 18900 },
  { "name": "Dr. Dennis Gross C+ Collagen Deep Cream", "price": 8200 },
  { "name": "Sunday Riley Good Genes All-In-One Lactic Acid Treatment", "price": 7200 },

  { "name": "Giorgio Armani Luminous Silk Foundation", "price": 5200 },
  { "name": "Lancôme Teint Idole Ultra Wear Foundation", "price": 4800 },
  { "name": "NARS Natural Radiant Longwear Foundation", "price": 4900 },
  { "name": "Laura Mercier Flawless Fusion Ultra-Longwear Foundation", "price": 4600 },
  { "name": "Too Faced Born This Way Foundation", "price": 4200 },
  { "name": "Fenty Beauty Pro Filt’r Soft Matte Foundation", "price": 3990 },
  { "name": "Rare Beauty Liquid Touch Weightless Foundation", "price": 3700 },
  { "name": "Milk Makeup Flex Foundation Stick", "price": 3900 },
  { "name": "Ilia Super Serum Skin Tint SPF 40", "price": 4200 },
  { "name": "KVD Beauty Good Apple Foundation Balm", "price": 4100 },

  { "name": "Byredo Gypsy Water Eau de Parfum 100ml", "price": 14500 },
  { "name": "Le Labo Santal 33 Eau de Parfum 100ml", "price": 15500 },
  { "name": "Diptyque Eau Rose Eau de Toilette 100ml", "price": 9800 },
  { "name": "Penhaligon’s The Tragedy of Lord George 75ml", "price": 18500 },
  { "name": "Frederic Malle Portrait of a Lady 100ml", "price": 26500 },
  { "name": "Amouage Reflection Man Eau de Parfum 100ml", "price": 28500 },
  { "name": "Initio Parfums Privés Oud for Greatness 90ml", "price": 29500 },
  { "name": "Roja Parfums Elysium Pour Homme 100ml", "price": 32500 },
  { "name": "Bvlgari Le Gemme Tygar Eau de Parfum 100ml", "price": 28900 },
  { "name": "Maison Margiela Replica Jazz Club 100ml", "price": 11800 },

  { "name": "Shu Uemura Essence Absolue Nourishing Oil 150ml", "price": 4200 },
  { "name": "Sachajuan Intensive Hair Oil 100ml", "price": 3900 },
  { "name": "Virtue Healing Oil 50ml", "price": 3600 },
  { "name": "Rahua Elixir Hair Oil 30ml", "price": 5200 },
  { "name": "Leonor Greyl L’Huile de Leonor Greyl 95ml", "price": 4800 },
  { "name": "Alterna Caviar Anti-Aging Replenishing Moisture Shampoo", "price": 4200 },
  { "name": "Philip B Russian Amber Imperial Shampoo 355ml", "price": 8900 },
  { "name": "Christophe Robin Cleansing Purifying Scrub", "price": 3600 },
  { "name": "Oribe Serene Scalp Soothing Leave-On Treatment", "price": 5200 },
  { "name": "Bumble and Bumble Hairdresser’s Invisible Oil", "price": 3200 },

  { "name": "Juicy Chemistry Organic Argan Oil", "price": 950 },
  { "name": "Plum Vitamin C Serum", "price": 550 },
  { "name": "Just Herbs Herb Enriched Lipsticks", "price": 1295 },
  { "name": "Kama Ayurveda Rose Water", "price": 895 },
  { "name": "SoulTree Bhringraj Hair Oil", "price": 1095 },
  { "name": "Biotique Bio Papaya Revitalizing Tan Removal Scrub", "price": 280 },
  { "name": "Mamaearth Ubtan Face Mask", "price": 599 },
  { "name": "WOW Skin Science Onion Hair Oil", "price": 499 },
  { "name": "The Moms Co. Natural Hair Strengthening Oil", "price": 699 },
  { "name": "Forest Essentials Facial Ubtan Narangi & Nagkesar", "price": 1450 },

  { "name": "The Ordinary Niacinamide 10% + Zinc 1%", "price": 950 },
  { "name": "Paula’s Choice Skin Perfecting 2% BHA Liquid", "price": 1850 },
  { "name": "COSRX BHA Blackhead Power Liquid", "price": 1850 },
  { "name": "Drunk Elephant Protini Polypeptide Cream", "price": 7200 },
  { "name": "Glow Recipe Watermelon Glow Sleeping Mask", "price": 3200 },
  { "name": "Tatcha The Water Cream", "price": 7800 },
  { "name": "Laneige Lip Sleeping Mask", "price": 1200 },
  { "name": "Kiehl’s Midnight Recovery Concentrate", "price": 2950 },
  { "name": "Shiseido Benefiance Wrinkle Smoothing Cream", "price": 8500 },
  { "name": "Pixi Rose Tonic", "price": 1450 },



  { "name": "Tata Harper Repairative Moisturizer 50ml", "price": 9200 },
  { "name": "Dr. Hauschka Rose Day Cream 30ml", "price": 4200 },
  { "name": "Herbivore Botanicals Prism Exfoliating Glow Serum", "price": 5800 },
  { "name": "True Botanicals Renew Pure Radiance Oil", "price": 8900 },
  { "name": "Juice Beauty Stem Cellular Anti-Wrinkle Booster Serum", "price": 6200 },
  { "name": "REN Clean Skincare Evercalm Global Protection Day Cream", "price": 3800 },
  { "name": "Indie Lee Brightening Cleanser", "price": 3200 },
  { "name": "Drunk Elephant B-Hydra Intensive Hydration Serum", "price": 7200 },
  { "name": "Youth To The People Superfood Antioxidant Cleanser", "price": 2800 },
  { "name": "Caudalie Vinoperfect Radiance Serum", "price": 4600 },

  { "name": "Ilia True Skin Serum Foundation", "price": 4200 },
  { "name": "RMS Beauty Un Cover-Up Cream Foundation", "price": 3900 },
  { "name": "Kosas Revealer Skin-Improving Foundation SPF 25", "price": 4100 },
  { "name": "Westman Atelier Vital Skin Foundation Stick", "price": 7200 },
  { "name": "Vapour Beauty Soft Focus Foundation", "price": 3800 },
  { "name": "Lilah B. Flawless Finish Foundation", "price": 4500 },
  { "name": "Jane Iredale PurePressed Base Mineral Foundation", "price": 3600 },
  { "name": "Alima Pure Satin Matte Foundation", "price": 3200 },
  { "name": "100% Pure Fruit Pigmented Foundation", "price": 3400 },
  { "name": "Sappho New Paradigm Essential Foundation", "price": 3700 },

  { "name": "Tocca Florence Eau de Parfum 50ml", "price": 6800 },
  { "name": "Clean Reserve Warm Cotton Eau de Parfum 100ml", "price": 9800 },
  { "name": "The 7 Virtues Vanilla Woods Eau de Parfum 50ml", "price": 7200 },
  { "name": "Skylar Capri Summer Eau de Parfum 50ml", "price": 6400 },
  { "name": "Henry Rose Torn Eau de Parfum 50ml", "price": 8900 },
  { "name": "Phlur Missing Person Eau de Parfum 50ml", "price": 7600 },
  { "name": "Maison Louis Marie No.04 Bois de Balincourt", "price": 6200 },
  { "name": "DedCool Fragrance 01 'Taunt' Eau de Parfum", "price": 5800 },
  { "name": "Lake & Skye 11 11 Eau de Parfum", "price": 5400 },
  { "name": "Ellis Brooklyn Myth Eau de Parfum 50ml", "price": 7200 },

  { "name": "Rahua Classic Shampoo 275ml", "price": 4200 },
  { "name": "Innersense Organic Beauty Hydrating Cream Hairbath", "price": 3600 },
  { "name": "Josh Rosebrook Balance Shampoo", "price": 3900 },
  { "name": "Tabitha James Kraan Organic Hair Cleanser", "price": 5200 },
  { "name": "John Masters Organics Lavender & Avocado Intensive Conditioner", "price": 4800 },
  { "name": "Yarok Feed Your Moisture Shampoo", "price": 3400 },
  { "name": "EVOLVh UltraShine Moisture Shampoo", "price": 3200 },
  { "name": "Oway Rebuilding Hair Bath", "price": 5600 },
  { "name": "Briogeo Scalp Revival Charcoal + Coconut Oil Shampoo", "price": 3900 },
  { "name": "Seed Phytonutrients Daily Hair Cleanser", "price": 2800 },

  { "name": "Just Herbs Ayurvedic BB Cream", "price": 1295 },
  { "name": "Juicy Chemistry Organic Aloe Vera Gel", "price": 950 },
  { "name": "Plum E-Luminence Deep Moisturizing Cream", "price": 550 },
  { "name": "Kama Ayurveda Mridul Soap-Free Face Cleanser", "price": 895 },
  { "name": "SoulTree Hibiscus Shampoo with Honey & Aloe Vera", "price": 1095 },
  { "name": "Biotique Bio Almond Oil Nourishing Body Soap", "price": 280 },
  { "name": "Mamaearth Tea Tree Face Wash", "price": 599 },
  { "name": "WOW Skin Science Vitamin C Face Cream", "price": 499 },
  { "name": "The Moms Co. Natural Baby Shampoo", "price": 699 },
  { "name": "Forest Essentials Lip Balm Sugared Rose Petal", "price": 1450 },

  { "name": "The Ordinary Hyaluronic Acid 2% + B5", "price": 950 },
  { "name": "Paula’s Choice C15 Super Booster", "price": 1850 },
  { "name": "COSRX Snail Mucin Essence", "price": 1850 },
  { "name": "Drunk Elephant Lala Retro Whipped Cream", "price": 7200 },
  { "name": "Glow Recipe Plum Plump Hyaluronic Cream", "price": 3200 },
  { "name": "Tatcha The Silk Peony Eye Cream", "price": 7800 },
  { "name": "Laneige Cream Skin Refiner", "price": 1200 },
  { "name": "Kiehl’s Calendula Herbal Extract Toner", "price": 2950 },
  { "name": "Shiseido White Lucent Brightening Gel Cream", "price": 8500 },
  { "name": "Pixi Vitamin-C Tonic", "price": 1450 },


  { "name": "La Mer The Eye Concentrate 15ml", "price": 16500 },
  { "name": "Sisley Paris Sisleÿa L’Integral Anti-Age Cream 50ml", "price": 29500 },
  { "name": "Clé de Peau Beauté Radiant Multi Repair Oil 75ml", "price": 24500 },
  { "name": "Valmont V-Line Lifting Cream 50ml", "price": 26500 },
  { "name": "Omorovicza Queen of Hungary Mist 100ml", "price": 8200 },
  { "name": "Chantecaille Rose de Mai Cream 50ml", "price": 18900 },
  { "name": "Dr. Barbara Sturm Glow Drops 30ml", "price": 14500 },
  { "name": "Augustinus Bader The Eye Cream 15ml", "price": 18500 },
  { "name": "Tatcha Violet-C Brightening Serum 30ml", "price": 7800 },
  { "name": "Sunday Riley CEO Vitamin C Serum 30ml", "price": 7200 },

  { "name": "Tom Ford Traceless Soft Matte Foundation", "price": 8900 },
  { "name": "Guerlain Parure Gold Radiance Foundation", "price": 9200 },
  { "name": "YSL All Hours Foundation", "price": 5900 },
  { "name": "Charlotte Tilbury Beautiful Skin Foundation", "price": 4200 },
  { "name": "Pat McGrath Labs Skin Fetish Sublime Foundation", "price": 7200 },
  { "name": "Hourglass Vanish Seamless Finish Foundation Stick", "price": 6200 },
  { "name": "Huda Beauty Glowish Skin Tint", "price": 3990 },
  { "name": "Dior Forever Skin Glow Foundation", "price": 6200 },
  { "name": "Lancôme Skin Feels Good Hydrating Tint", "price": 4800 },
  { "name": "NARS Soft Matte Complete Foundation", "price": 4900 },

  { "name": "Maison Francis Kurkdjian Oud Satin Mood 70ml", "price": 28500 },
  { "name": "Creed Silver Mountain Water 100ml", "price": 32500 },
  { "name": "Chanel Les Exclusifs de Chanel Beige 75ml", "price": 21500 },
  { "name": "Dior La Collection Privée Ambre Nuit 125ml", "price": 24500 },
  { "name": "Gucci The Alchemist’s Garden A Gloaming Night 100ml", "price": 26500 },
  { "name": "YSL Le Vestiaire Des Parfums Tuxedo 125ml", "price": 22900 },
  { "name": "Valentino Voce Viva Intensa 100ml", "price": 10900 },
  { "name": "Hermès Eau de Basilic Pourpre 100ml", "price": 9800 },
  { "name": "Jo Malone Myrrh & Tonka Cologne Intense 100ml", "price": 11800 },
  { "name": "Diptyque Philosykos Eau de Parfum 75ml", "price": 14500 },

  { "name": "Oribe Gold Lust Transformative Masque 250ml", "price": 5200 },
  { "name": "Kerastase Chronologiste Revitalizing Shampoo 250ml", "price": 4200 },
  { "name": "Olaplex No.8 Bond Intense Moisture Mask 100ml", "price": 3200 },
  { "name": "Briogeo Farewell Frizz Blow Dry Perfection Heat Protectant", "price": 3900 },
  { "name": "Aveda Botanical Repair Strengthening Leave-In Treatment", "price": 3400 },
  { "name": "Philip Kingsley Moisture Balancing Shampoo", "price": 4600 },
  { "name": "Living Proof Full Dry Volume Blast", "price": 2800 },
  { "name": "OUAI Detox Shampoo", "price": 3200 },
  { "name": "Christophe Robin Hydrating Melting Mask", "price": 5600 },
  { "name": "Virtue Recovery Shampoo", "price": 3600 },

  { "name": "Forest Essentials Tejasvi Emulsion", "price": 5950 },
  { "name": "Kama Ayurveda Eladi Hydrating Ayurvedic Face Cream", "price": 2850 },
  { "name": "Plum Chamomile & White Tea Night Cream", "price": 390 },
  { "name": "Just Herbs Herb Enriched Lip & Cheek Tint", "price": 1295 },
  { "name": "Juicy Chemistry Organic Lavender Water", "price": 950 },
  { "name": "SoulTree Turmeric & Indian Rose Face Wash", "price": 895 },
  { "name": "Biotique Bio Honey Gel Face Wash", "price": 280 },
  { "name": "Mamaearth Rice Water Hair Mask", "price": 599 },
  { "name": "WOW Skin Science Coconut Milk Shampoo", "price": 499 },
  { "name": "The Moms Co. Natural Clay Face Mask", "price": 699 },

  { "name": "Clinique Smart Clinical Repair Wrinkle Correcting Serum", "price": 4200 },
  { "name": "The Body Shop Vitamin E Moisture Cream", "price": 2995 },
  { "name": "L'Occitane Almond Milk Concentrate", "price": 7200 },
  { "name": "Laneige Radiant-C Cream", "price": 2200 },
  { "name": "Innisfree Jeju Orchid Enriched Cream", "price": 2150 },
  { "name": "Kiehl’s Clearly Corrective Dark Spot Solution", "price": 2950 },
  { "name": "Shiseido Vital Perfection Uplifting Cream", "price": 8500 },
  { "name": "Pixi Milky Tonic", "price": 1450 },
  { "name": "COSRX Propolis Light Ampoule", "price": 1850 },
  { "name": "Drunk Elephant Shaba Complex Eye Serum", "price": 7200 },


                  ],
                  "Lifestyle Boutiques": [

    { "name": "Dior Maison Entrelacé Cushion", "price": 28500 },
  { "name": "Chumbak Mandala Wall Art Frame", "price": 1495 },
  { "name": "Good Earth Scented Soy Candle – Samarkand", "price": 3200 },
  { "name": "Nicobar Brass Candle Holder", "price": 1800 },
  { "name": "IKEA GLIMMA Unscented Candles (Pack of 24)", "price": 428 },
  { "name": "Home Centre Boutique Jar Candle – Lime Basil Mandarin", "price": 599 },
  { "name": "Palatial Lifestyles Scented Candle Set of 6", "price": 379 },
  { "name": "The Natural House Bouquet Candle", "price": 599 },
  { "name": "AuraDecor Lavender Pillar Candle Set", "price": 269 },
  { "name": "Bella Vita Organic Soy Wax Aroma Candles (Set of 4)", "price": 325 },

  { "name": "Dior Maison Decorative Dinner Plate", "price": 21500 },
  { "name": "Alicia DiMichele Manifest Needlepoint Pillow", "price": 9800 },
  { "name": "ThinkArtDecor Luxury Sandalwood Candle", "price": 499 },
  { "name": "Hello Handmade Boat in a Jar Candle", "price": 690 },
  { "name": "eCraftIndia French Lavender Jar Candle", "price": 179 },
  { "name": "House of Aroma Beeswax Jar Candles (Set of 3)", "price": 539 },
  { "name": "Home Boutique Wine Bottle Shaped Candles (Pack of 8)", "price": 350 },
  { "name": "CLOUD Essentials Soy Wax Candle – Stress Relief", "price": 385 },
  { "name": "Home Centre Boutique Reed Diffuser Giftset", "price": 1499 },
  { "name": "LA INDUSTRIES Vanilla Fantasy Candle (Pack of 2)", "price": 149 },

  { "name": "Suspire Bare Necessities Luxury Skin Care Gift Set", "price": 1400 },
  { "name": "Suspire Iris Eyes That Slay Gift Box", "price": 1921 },
  { "name": "Suspire Eco-Luxe Gift Set", "price": 2050 },
  { "name": "Suspire Gentleman's Elegance Care Kit", "price": 1385 },
  { "name": "Suspire Nature's Bliss Gift Box", "price": 1599 },
  { "name": "Suspire Glow & Pamper Gift Box", "price": 2499 },
  { "name": "Suspire Refresh & Relax Essentials Gift Box", "price": 400 },
  { "name": "Suspire Bare Upcycled Pouches with Cutlery", "price": 799 },
  { "name": "Suspire Sustainable Grooming Kit", "price": 1999 },
  { "name": "Suspire Festive Treats Gift Box", "price": 1850 },

  { "name": "Etsy Inspirational Desk Frame Set", "price": 199 },
  { "name": "Etsy Affirmation Card Set Mockup", "price": 224 },
  { "name": "Etsy Guided Meditation Tracker", "price": 104 },
  { "name": "Etsy Monthly Affirmation Planner 2025", "price": 466 },
  { "name": "Etsy Lara Lane Wellness Coach Logo", "price": 2063 },
  { "name": "Etsy Botanical Logo Design", "price": 3095 },
  { "name": "Etsy Wellness Planner Bundle", "price": 716 },
  { "name": "Etsy Self-Care Gift Box – Black Owned", "price": 4378 },
  { "name": "Etsy Wellness Lead Magnet Ebook", "price": 764 },
  { "name": "Etsy Wellness Spa Gift Box", "price": 4341 },

  { "name": "Amazon PURETIVE Good Vibes Gift Box", "price": 881 },
  { "name": "Amazon Herbal Brews Spa Kit", "price": 549 },
  { "name": "Amazon Aroma Treasures Shower Steamers", "price": 299 },
  { "name": "Amazon CHAYAM Tea Retreat Gift Box", "price": 597 },
  { "name": "Amazon Kimirica Love Story Bath Gift Set", "price": 999 },
  { "name": "Amazon Bella Vita Perfume Gift Set", "price": 499 },
  { "name": "Amazon CHAYAM Luxury Tea Gift Set", "price": 1509 },
  { "name": "Amazon SPA CEYLON Sleep Wellness Trio", "price": 980 },
  { "name": "Amazon Rivona Naturals Wellness Gift Set", "price": 799 },
  { "name": "Amazon OH CHA Ikigai Tea Gift Box", "price": 1049 },

  { "name": "Amazon KraftsKala Ceramic Oil Diffuser", "price": 499 },
  { "name": "Amazon ARUZEN Jar of Quotes – Wellness Edition", "price": 206 },
  { "name": "Amazon Vincenzo Jar of Positivity", "price": 249 },
  { "name": "Amazon LOUIS MILLER 24K Gold Magnetic Bracelet", "price": 499 },
  { "name": "Amazon Lifelong Foot Massager Machine", "price": 4499 },
  { "name": "Amazon ZYNTO Shiatsu Foot Massager", "price": 2349 },
  { "name": "Amazon Herb Tantra Hustler Gift Combo", "price": 799 },
  { "name": "Amazon Eat Better Co. New Mom Gift Box", "price": 1449 },
  { "name": "Amazon CHAYAM Green Tea Bags Gift Set", "price": 775 },
  { "name": "Amazon The Tea Heaven Herbal Tea Collection", "price": 427 },

  { "name": "Dior Maison Decorative Candle", "price": 21500 },
  { "name": "Dior Maison Embroidered Cushion", "price": 28500 },
  { "name": "Dior Maison Wall Art – Entrelacé", "price": 32500 },
  { "name": "Dior Maison Luxury Gift Tray", "price": 18900 },
  { "name": "Dior Maison Designer Ornament Set", "price": 24900 },


  { "name": "Good Earth Silk Cushion – Mughal Garden", "price": 9800 },
  { "name": "Nicobar Handwoven Cotton Cushion – Indigo", "price": 2200 },
  { "name": "Chumbak Quirky Printed Cushion – Owl", "price": 1295 },
  { "name": "IKEA VINDKAST Cushion Cover", "price": 499 },
  { "name": "Dior Maison Embroidered Cushion – Entrelacé", "price": 28500 },
  { "name": "Alicia DiMichele Manifest Needlepoint Pillow", "price": 9800 },
  { "name": "Home Centre Velvet Cushion – Teal", "price": 899 },
  { "name": "Urban Ladder Printed Cushion Set", "price": 1499 },
  { "name": "FabIndia Block Print Cushion Cover", "price": 750 },
  { "name": "The Yellow Dwelling Linen Cushion", "price": 1299 },

  { "name": "Dior Maison Wall Art – Entrelacé", "price": 32500 },
  { "name": "Chumbak Mandala Wall Frame", "price": 1495 },
  { "name": "Nicobar Brass Wall Hanging – Crescent", "price": 1800 },
  { "name": "IKEA BJÖRKSTA Canvas Print", "price": 2999 },
  { "name": "Home Centre Abstract Wall Art", "price": 1599 },
  { "name": "The Wishing Chair Botanical Wall Plate", "price": 1295 },
  { "name": "Jaypore Hand-Painted Wall Panel", "price": 4999 },
  { "name": "Artisanal Jaipur Miniature Painting", "price": 7200 },
  { "name": "The Decor Kart Vintage Wall Clock", "price": 3495 },
  { "name": "The House of Things Marble Inlay Wall Art", "price": 18500 },

  { "name": "Suspire Eco-Luxe Gift Set", "price": 2050 },
  { "name": "Suspire Nature's Bliss Gift Box", "price": 1599 },
  { "name": "Suspire Gentleman's Elegance Kit", "price": 1385 },
  { "name": "Suspire Glow & Pamper Gift Box", "price": 2499 },
  { "name": "Suspire Bare Necessities Luxury Set", "price": 1400 },
  { "name": "Suspire Festive Treats Gift Box", "price": 1850 },
  { "name": "Suspire Sustainable Grooming Kit", "price": 1999 },
  { "name": "Suspire Iris Eyes That Slay Box", "price": 1921 },
  { "name": "Suspire Refresh & Relax Essentials", "price": 400 },
  { "name": "Suspire Bare Upcycled Pouches", "price": 799 },

  { "name": "Etsy Self-Care Gift Box – Black Owned", "price": 4378 },
  { "name": "Etsy Wellness Spa Gift Box", "price": 4341 },
  { "name": "Etsy Affirmation Card Set", "price": 224 },
  { "name": "Etsy Inspirational Desk Frame Set", "price": 199 },
  { "name": "Etsy Guided Meditation Tracker", "price": 104 },
  { "name": "Etsy Monthly Affirmation Planner", "price": 466 },
  { "name": "Etsy Botanical Logo Design", "price": 3095 },
  { "name": "Etsy Wellness Planner Bundle", "price": 716 },
  { "name": "Etsy Lara Lane Wellness Coach Logo", "price": 2063 },
  { "name": "Etsy Wellness Lead Magnet Ebook", "price": 764 },

  { "name": "Amazon PURETIVE Good Vibes Gift Box", "price": 881 },
  { "name": "Amazon Herbal Brews Spa Kit", "price": 549 },
  { "name": "Amazon Aroma Treasures Shower Steamers", "price": 299 },
  { "name": "Amazon CHAYAM Tea Retreat Gift Box", "price": 597 },
  { "name": "Amazon Kimirica Love Story Bath Set", "price": 999 },
  { "name": "Amazon Bella Vita Perfume Gift Set", "price": 499 },
  { "name": "Amazon SPA CEYLON Sleep Wellness Trio", "price": 980 },
  { "name": "Amazon Rivona Naturals Wellness Set", "price": 799 },
  { "name": "Amazon OH CHA Ikigai Tea Gift Box", "price": 1049 },
  { "name": "Amazon KraftsKala Ceramic Oil Diffuser", "price": 499 },

  { "name": "Amazon ARUZEN Jar of Quotes – Wellness Edition", "price": 206 },
  { "name": "Amazon Vincenzo Jar of Positivity", "price": 249 },
  { "name": "Amazon LOUIS MILLER 24K Gold Bracelet", "price": 499 },
  { "name": "Amazon Lifelong Foot Massager Machine", "price": 4499 },
  { "name": "Amazon ZYNTO Shiatsu Foot Massager", "price": 2349 },
  { "name": "Amazon Herb Tantra Hustler Combo", "price": 799 },
  { "name": "Amazon Eat Better Co. New Mom Box", "price": 1449 },
  { "name": "Amazon CHAYAM Green Tea Bags Set", "price": 775 },
  { "name": "Amazon The Tea Heaven Herbal Collection", "price": 427 },
  { "name": "Amazon The Natural House Penguin Candle", "price": 245 },

  { "name": "Dior Maison Luxury Gift Tray", "price": 18900 },
  { "name": "Dior Maison Designer Ornament Set", "price": 24900 },
  { "name": "Dior Maison Decorative Candle", "price": 21500 },
  { "name": "Dior Maison Embroidered Cushion", "price": 28500 },
  { "name": "Dior Maison Entrelacé Wall Art", "price": 32500 },


  { "name": "Good Earth Silk Cushion – Pichwai Lotus", "price": 9800 },
  { "name": "Nicobar Handwoven Cushion – Coral", "price": 2200 },
  { "name": "Chumbak Printed Cushion – Elephant Parade", "price": 1295 },
  { "name": "IKEA SANELA Velvet Cushion Cover", "price": 499 },
  { "name": "FabIndia Kantha Embroidered Cushion", "price": 750 },
  { "name": "The Yellow Dwelling Cotton Cushion", "price": 1299 },
  { "name": "Urban Ladder Abstract Cushion Set", "price": 1499 },
  { "name": "Home Centre Embellished Cushion – Gold", "price": 899 },
  { "name": "Jaypore Handloom Silk Cushion", "price": 3200 },
  { "name": "The Decor Kart Velvet Cushion – Royal Blue", "price": 1895 },

  { "name": "Jaypore Madhubani Wall Panel", "price": 4999 },
  { "name": "Artisanal Jaipur Pichwai Painting", "price": 7200 },
  { "name": "The House of Things Marble Inlay Wall Art", "price": 18500 },
  { "name": "The Decor Kart Vintage Wall Clock – Roman", "price": 3495 },
  { "name": "Chumbak Quirky Wall Plate – Auto Rickshaw", "price": 1295 },
  { "name": "Nicobar Brass Crescent Wall Hanging", "price": 1800 },
  { "name": "IKEA BJÖRKSTA Canvas Print – Forest", "price": 2999 },
  { "name": "Home Centre Botanical Wall Art", "price": 1599 },
  { "name": "The Wishing Chair Floral Wall Plate", "price": 1295 },
  { "name": "FabIndia Block Print Wall Hanging", "price": 1750 },

  { "name": "Suspire Luxe Wellness Gift Box", "price": 2499 },
  { "name": "Suspire Bare Necessities Grooming Kit", "price": 1999 },
  { "name": "Suspire Festive Treats Gift Box", "price": 1850 },
  { "name": "Suspire Nature's Bliss Spa Set", "price": 1599 },
  { "name": "Suspire Glow & Pamper Essentials", "price": 2050 },
  { "name": "Suspire Gentleman's Elegance Kit", "price": 1385 },
  { "name": "Suspire Iris Eyes That Slay Box", "price": 1921 },
  { "name": "Suspire Refresh & Relax Essentials", "price": 400 },
  { "name": "Suspire Upcycled Pouches & Cutlery", "price": 799 },
  { "name": "Suspire Eco-Luxe Gift Set", "price": 2050 },

  { "name": "Etsy Botanical Logo Design", "price": 3095 },
  { "name": "Etsy Wellness Planner Bundle", "price": 716 },
  { "name": "Etsy Affirmation Card Set", "price": 224 },
  { "name": "Etsy Inspirational Desk Frame", "price": 199 },
  { "name": "Etsy Guided Meditation Tracker", "price": 104 },
  { "name": "Etsy Monthly Affirmation Planner", "price": 466 },
  { "name": "Etsy Wellness Spa Gift Box", "price": 4341 },
  { "name": "Etsy Self-Care Gift Box – Black Owned", "price": 4378 },
  { "name": "Etsy Wellness Lead Magnet Ebook", "price": 764 },
  { "name": "Etsy Lara Lane Wellness Coach Logo", "price": 2063 },

  { "name": "Amazon PURETIVE Good Vibes Gift Box", "price": 881 },
  { "name": "Amazon Herbal Brews Spa Kit", "price": 549 },
  { "name": "Amazon Aroma Treasures Shower Steamers", "price": 299 },
  { "name": "Amazon CHAYAM Tea Retreat Gift Box", "price": 597 },
  { "name": "Amazon Kimirica Love Story Bath Set", "price": 999 },
  { "name": "Amazon Bella Vita Perfume Gift Set", "price": 499 },
  { "name": "Amazon SPA CEYLON Sleep Wellness Trio", "price": 980 },
  { "name": "Amazon Rivona Naturals Wellness Set", "price": 799 },
  { "name": "Amazon OH CHA Ikigai Tea Gift Box", "price": 1049 },
  { "name": "Amazon KraftsKala Ceramic Oil Diffuser", "price": 499 },

  { "name": "Amazon ARUZEN Jar of Quotes – Wellness Edition", "price": 206 },
  { "name": "Amazon Vincenzo Jar of Positivity", "price": 249 },
  { "name": "Amazon LOUIS MILLER 24K Gold Bracelet", "price": 499 },
  { "name": "Amazon Lifelong Foot Massager Machine", "price": 4499 },
  { "name": "Amazon ZYNTO Shiatsu Foot Massager", "price": 2349 },
  { "name": "Amazon Herb Tantra Hustler Combo", "price": 799 },
  { "name": "Amazon Eat Better Co. New Mom Box", "price": 1449 },
  { "name": "Amazon CHAYAM Green Tea Bags Set", "price": 775 },
  { "name": "Amazon The Tea Heaven Herbal Collection", "price": 427 },
  { "name": "Amazon The Natural House Penguin Candle", "price": 245 },

  { "name": "Dior Maison Decorative Candle", "price": 21500 },
  { "name": "Dior Maison Embroidered Cushion", "price": 28500 },
  { "name": "Dior Maison Entrelacé Wall Art", "price": 32500 },
  { "name": "Dior Maison Luxury Gift Tray", "price": 18900 },
  { "name": "Dior Maison Designer Ornament Set", "price": 24900 },


  { "name": "Jaypore Silk Cushion – Peacock Motif", "price": 3200 },
  { "name": "FabIndia Handwoven Cushion – Indigo", "price": 750 },
  { "name": "The Decor Kart Velvet Cushion – Emerald", "price": 1895 },
  { "name": "Urban Ladder Geometric Cushion Set", "price": 1499 },
  { "name": "The Yellow Dwelling Linen Cushion – Ochre", "price": 1299 },
  { "name": "Chumbak Printed Cushion – Llama Love", "price": 1295 },
  { "name": "IKEA GURLI Cushion Cover", "price": 399 },
  { "name": "Nicobar Cotton Cushion – Sand", "price": 2200 },
  { "name": "Good Earth Silk Cushion – Mughal Bloom", "price": 9800 },
  { "name": "Dior Maison Embroidered Cushion – Jardin", "price": 28500 },

  { "name": "Jaypore Kalamkari Wall Panel", "price": 4999 },
  { "name": "Artisanal Jaipur Miniature Painting – Royal Court", "price": 7200 },
  { "name": "The House of Things Marble Inlay Wall Art – Lotus", "price": 18500 },
  { "name": "The Decor Kart Vintage Wall Clock – Antique Brass", "price": 3495 },
  { "name": "Chumbak Wall Plate – Funky Auto", "price": 1295 },
  { "name": "Nicobar Brass Wall Hanging – Moon Phase", "price": 1800 },
  { "name": "IKEA PJÄTTERYD Canvas Print – Abstract", "price": 2999 },
  { "name": "Home Centre Botanical Wall Art – Set of 3", "price": 1599 },
  { "name": "The Wishing Chair Floral Wall Plate – Dahlia", "price": 1295 },
  { "name": "FabIndia Block Print Wall Hanging – Paisley", "price": 1750 },

  { "name": "Suspire Luxe Wellness Gift Box – Rose & Sandalwood", "price": 2499 },
  { "name": "Suspire Bare Necessities Grooming Kit – Hemp Edition", "price": 1999 },
  { "name": "Suspire Festive Treats Gift Box – Eco Luxe", "price": 1850 },
  { "name": "Suspire Nature's Bliss Spa Set – Lavender", "price": 1599 },
  { "name": "Suspire Glow & Pamper Essentials – Citrus", "price": 2050 },
  { "name": "Suspire Gentleman's Elegance Kit – Charcoal", "price": 1385 },
  { "name": "Suspire Iris Eyes That Slay Box – Rose Gold", "price": 1921 },
  { "name": "Suspire Refresh & Relax Essentials – Mint", "price": 400 },
  { "name": "Suspire Upcycled Pouches & Cutlery – Travel Edition", "price": 799 },
  { "name": "Suspire Eco-Luxe Gift Set – Bamboo & Linen", "price": 2050 },

  { "name": "Etsy Botanical Logo Design – Wellness Brand", "price": 3095 },
  { "name": "Etsy Wellness Planner Bundle – Digital", "price": 716 },
  { "name": "Etsy Affirmation Card Set – Floral Edition", "price": 224 },
  { "name": "Etsy Inspirational Desk Frame – Minimalist", "price": 199 },
  { "name": "Etsy Guided Meditation Tracker – Printable", "price": 104 },
  { "name": "Etsy Monthly Affirmation Planner – 2025", "price": 466 },
  { "name": "Etsy Wellness Spa Gift Box – Self-Care", "price": 4341 },
  { "name": "Etsy Self-Care Gift Box – Black Owned", "price": 4378 },
  { "name": "Etsy Wellness Lead Magnet Ebook – Canva", "price": 764 },
  { "name": "Etsy Lara Lane Wellness Coach Logo", "price": 2063 },

  { "name": "Amazon PURETIVE Good Vibes Gift Box – Vegan", "price": 881 },
  { "name": "Amazon Herbal Brews Spa Kit – Wooden Box", "price": 549 },
  { "name": "Amazon Aroma Treasures Shower Steamers – Citrus", "price": 299 },
  { "name": "Amazon CHAYAM Tea Retreat Gift Box – Kashmiri Kahwa", "price": 597 },
  { "name": "Amazon Kimirica Love Story Bath Set – Lavender", "price": 999 },
  { "name": "Amazon Bella Vita Perfume Gift Set – 4x20ml", "price": 499 },
  { "name": "Amazon SPA CEYLON Sleep Wellness Trio – Ayurvedic", "price": 980 },
  { "name": "Amazon Rivona Naturals Wellness Set – Herbal", "price": 799 },
  { "name": "Amazon OH CHA Ikigai Tea Gift Box – 6 Flavours", "price": 1049 },
  { "name": "Amazon KraftsKala Ceramic Oil Diffuser – Teapot", "price": 499 },

  { "name": "Amazon ARUZEN Jar of Quotes – Wellness Edition", "price": 206 },
  { "name": "Amazon Vincenzo Jar of Positivity – Glass", "price": 249 },
  { "name": "Amazon LOUIS MILLER 24K Gold Bracelet – Magnetic", "price": 499 },
  { "name": "Amazon Lifelong Foot Massager Machine – Electric", "price": 4499 },
  { "name": "Amazon ZYNTO Shiatsu Foot Massager – Heated", "price": 2349 },
  { "name": "Amazon Herb Tantra Hustler Combo – Migraine Relief", "price": 799 },
  { "name": "Amazon Eat Better Co. New Mom Box – 10 Items", "price": 1449 },
  { "name": "Amazon CHAYAM Green Tea Bags Set – 48 Bags", "price": 775 },
  { "name": "Amazon The Tea Heaven Herbal Collection – 4 Types", "price": 427 },
  { "name": "Amazon The Natural House Penguin Candle – Soy Wax", "price": 245 },

  { "name": "Dior Maison Decorative Candle – Entrelacé", "price": 21500 },
  { "name": "Dior Maison Embroidered Cushion – Jardin", "price": 28500 },
  { "name": "Dior Maison Entrelacé Wall Art – Limited Edition", "price": 32500 },
  { "name": "Dior Maison Luxury Gift Tray – Gold Finish", "price": 18900 },
  { "name": "Dior Maison Designer Ornament Set – Holiday", "price": 24900 },


                  ],
                  "Bridal Boutiques": [

      { "name": "Sabyasachi Heritage Red Bridal Lehenga", "price": 425000 },
  { "name": "Manish Malhotra Ivory Sequin Gown", "price": 385000 },
  { "name": "Tarun Tahiliani Zardozi Embroidered Lehenga", "price": 295000 },
  { "name": "Ritu Kumar Regal Velvet Lehenga", "price": 185000 },
  { "name": "Falguni Shane Peacock Crystal Trail Gown", "price": 325000 },
  { "name": "Anita Dongre Pastel Floral Lehenga", "price": 145000 },
  { "name": "Abu Jani Sandeep Khosla Mirror Work Lehenga", "price": 365000 },
  { "name": "Shantanu & Nikhil Draped Tuxedo Set", "price": 98000 },
  { "name": "KALKI Fashion Gold Embellished Lehenga", "price": 89000 },
  { "name": "Chhabra 555 Maroon Bridal Lehenga", "price": 54000 },

  { "name": "Ensemble Mahima Mahajan Organza Lehenga", "price": 168200 },
  { "name": "Paulmi & Harsh Floral Embroidered Lehenga", "price": 238000 },
  { "name": "Amit Aggarwal Metallic Structured Gown", "price": 377000 },
  { "name": "Jayanti Reddy Zardosi Bridal Lehenga", "price": 289000 },
  { "name": "Ridhi Mehra Romantic Bridesmaid Lehenga", "price": 72000 },
  { "name": "Aisha Rao Maximalist Motif Lehenga", "price": 98000 },
  { "name": "Payal Singhal Printed Bridesmaid Cape Set", "price": 62000 },
  { "name": "Arpita Mehta Garden Print Bridesmaid Dress", "price": 58000 },
  { "name": "Mishru Floral Embroidered Bridesmaid Lehenga", "price": 69000 },
  { "name": "Torani Vermillion Bridal Lehenga", "price": 215000 },

  { "name": "Manyavar Classic Sherwani Set", "price": 18999 },
  { "name": "Mohey Bridal Saree Ensemble", "price": 24999 },
  { "name": "Mebaz Designer Tuxedo Set", "price": 28999 },
  { "name": "Wedding Lace Mermaid Gown", "price": 18500 },
  { "name": "GownLink Ball Gown with Train", "price": 22999 },
  { "name": "GownLink Bridal Veil Cathedral Length", "price": 4999 },
  { "name": "GownLink Bridal Gloves Satin Opera", "price": 2999 },
  { "name": "GownLink Crown Tiara Set", "price": 3999 },
  { "name": "Wedding Lace Bridal Accessories Combo", "price": 5999 },
  { "name": "Wedding Lace Baptism Dress", "price": 3499 },

  { "name": "Indya Bridesmaid Traditional Lehenga", "price": 4999 },
  { "name": "Indya Floral Embroidered Bridesmaid Dress", "price": 3999 },
  { "name": "Indya Sequin Bridesmaid Gown", "price": 5999 },
  { "name": "Indya Printed Kurta Set for Bridesmaids", "price": 2999 },
  { "name": "Indya Mirror Work Sharara Set", "price": 3499 },
  { "name": "Indya Pastel Bridesmaid Lehenga", "price": 4500 },
  { "name": "Indya Indo-Western Crop Top Set", "price": 3800 },
  { "name": "Indya Reception Wear Gown", "price": 6200 },
  { "name": "Indya Haldi Ceremony Kurta Set", "price": 2800 },
  { "name": "Indya Mehendi Wear Lehenga", "price": 3200 },

  { "name": "Myntra Boohoo Chiffon Bridesmaid Dress", "price": 4224 },
  { "name": "Myntra Berrylush Romantic Florals Dress", "price": 779 },
  { "name": "Myntra Athena Solid Cut-Out Dress", "price": 674 },
  { "name": "Myntra Style Quotient Puff Sleeves Dress", "price": 400 },
  { "name": "Myntra DODO & MOA Flutter Sleeves Dress", "price": 988 },
  { "name": "Myntra U&F Bustier Bridesmaid Dress", "price": 781 },
  { "name": "Myntra PANIT Ethnic Spaghetti Dress", "price": 2589 },
  { "name": "Myntra emeros Crepe Maxi Dress", "price": 979 },
  { "name": "Myntra Boohoo Pleated Midi Bridesmaid Dress", "price": 1674 },
  { "name": "Myntra plusS Floral Volume Play Dress", "price": 459 },

  { "name": "Amazon Zeel Clothing Heavy Embroidered Bridal Lehenga", "price": 3229 },
  { "name": "Amazon TRENDMALLS Satin Embroidery Lehenga", "price": 2949 },
  { "name": "Amazon Monrav Silk Semi-Stitched Lehenga", "price": 2000 },
  { "name": "Amazon Divine Exim Net Embroidered Lehenga", "price": 5599 },
  { "name": "Amazon Zeel Clothing Sequins Net Lehenga", "price": 4274 },
  { "name": "Amazon Generic Omkar Tex Bridal Lehenga", "price": 2989 },
  { "name": "Amazon VARNI FABRICS Net Embroidered Lehenga", "price": 2349 },
  { "name": "Amazon Zeel Clothing Raw Silk Lehenga", "price": 3399 },
  { "name": "Amazon Zeel Clothing Organza Floral Lehenga", "price": 3229 },
  { "name": "Amazon Zeel Clothing Threads Sequins Lehenga", "price": 4274 },


  { "name": "Manish Malhotra Gold Embellished Bridal Lehenga", "price": 395000 },
  { "name": "Sabyasachi Royal Blue Velvet Lehenga", "price": 445000 },
  { "name": "Tarun Tahiliani Ivory Draped Gown", "price": 315000 },
  { "name": "Falguni Shane Peacock Feather Trail Gown", "price": 355000 },
  { "name": "Anita Dongre Handwoven Banarasi Lehenga", "price": 165000 },
  { "name": "Abu Jani Sandeep Khosla Pearl Embroidered Lehenga", "price": 385000 },
  { "name": "Shantanu & Nikhil Regal Tuxedo Set", "price": 105000 },
  { "name": "Ritu Kumar Brocade Bridal Saree", "price": 145000 },
  { "name": "Jayanti Reddy Zardosi Bridal Lehenga", "price": 289000 },
  { "name": "Amit Aggarwal Metallic Sculpted Gown", "price": 377000 },

  { "name": "Paulmi & Harsh Floral Bridesmaid Lehenga", "price": 238000 },
  { "name": "Mahima Mahajan Organza Bridesmaid Set", "price": 168200 },
  { "name": "Ridhi Mehra Romantic Bridesmaid Gown", "price": 72000 },
  { "name": "Aisha Rao Maximalist Motif Lehenga", "price": 98000 },
  { "name": "Payal Singhal Printed Cape Set", "price": 62000 },
  { "name": "Arpita Mehta Garden Print Dress", "price": 58000 },
  { "name": "Mishru Floral Embroidered Lehenga", "price": 69000 },
  { "name": "Torani Vermillion Bridal Lehenga", "price": 215000 },
  { "name": "Ritika Mirchandani Pastel Lehenga", "price": 88000 },
  { "name": "Varun Bahl 3D Embroidered Cape Gown", "price": 92000 },

  { "name": "Manyavar Regal Sherwani Set", "price": 18999 },
  { "name": "Mohey Bridal Saree Ensemble", "price": 24999 },
  { "name": "Mebaz Designer Tuxedo Set", "price": 28999 },
  { "name": "Wedding Lace Mermaid Gown", "price": 18500 },
  { "name": "GownLink Ball Gown with Train", "price": 22999 },
  { "name": "GownLink Cathedral Veil", "price": 4999 },
  { "name": "GownLink Satin Opera Gloves", "price": 2999 },
  { "name": "GownLink Crown Tiara Set", "price": 3999 },
  { "name": "Wedding Lace Accessories Combo", "price": 5999 },
  { "name": "Wedding Lace Baptism Dress", "price": 3499 },

  { "name": "Indya Traditional Bridesmaid Lehenga", "price": 4999 },
  { "name": "Indya Floral Bridesmaid Dress", "price": 3999 },
  { "name": "Indya Sequin Bridesmaid Gown", "price": 5999 },
  { "name": "Indya Printed Kurta Set", "price": 2999 },
  { "name": "Indya Mirror Work Sharara", "price": 3499 },
  { "name": "Indya Pastel Lehenga", "price": 4500 },
  { "name": "Indya Crop Top Set", "price": 3800 },
  { "name": "Indya Reception Gown", "price": 6200 },
  { "name": "Indya Haldi Kurta Set", "price": 2800 },
  { "name": "Indya Mehendi Lehenga", "price": 3200 },

  { "name": "Myntra Boohoo Chiffon Dress", "price": 4224 },
  { "name": "Myntra Berrylush Floral Dress", "price": 779 },
  { "name": "Myntra Athena Cut-Out Dress", "price": 674 },
  { "name": "Myntra Style Quotient Puff Dress", "price": 400 },
  { "name": "Myntra DODO & MOA Flutter Dress", "price": 988 },
  { "name": "Myntra U&F Bustier Dress", "price": 781 },
  { "name": "Myntra PANIT Ethnic Dress", "price": 2589 },
  { "name": "Myntra emeros Maxi Dress", "price": 979 },
  { "name": "Myntra Boohoo Pleated Midi Dress", "price": 1674 },
  { "name": "Myntra plusS Volume Play Dress", "price": 459 },

  { "name": "Amazon Zeel Heavy Embroidered Lehenga", "price": 3229 },
  { "name": "Amazon TRENDMALLS Satin Lehenga", "price": 2949 },
  { "name": "Amazon Monrav Silk Lehenga", "price": 2000 },
  { "name": "Amazon Divine Exim Net Lehenga", "price": 5599 },
  { "name": "Amazon Zeel Sequins Net Lehenga", "price": 4274 },
  { "name": "Amazon Omkar Tex Bridal Lehenga", "price": 2989 },
  { "name": "Amazon VARNI FABRICS Net Lehenga", "price": 2349 },
  { "name": "Amazon Zeel Raw Silk Lehenga", "price": 3399 },
  { "name": "Amazon Zeel Organza Floral Lehenga", "price": 3229 },
  { "name": "Amazon Zeel Threads Sequins Lehenga", "price": 4274 },


  { "name": "Manish Malhotra Gold Embellished Bridal Lehenga", "price": 395000 },
  { "name": "Sabyasachi Royal Blue Velvet Lehenga", "price": 445000 },
  { "name": "Tarun Tahiliani Ivory Draped Gown", "price": 315000 },
  { "name": "Falguni Shane Peacock Feather Trail Gown", "price": 355000 },
  { "name": "Anita Dongre Handwoven Banarasi Lehenga", "price": 165000 },
  { "name": "Abu Jani Sandeep Khosla Pearl Embroidered Lehenga", "price": 385000 },
  { "name": "Shantanu & Nikhil Regal Tuxedo Set", "price": 105000 },
  { "name": "Ritu Kumar Brocade Bridal Saree", "price": 145000 },
  { "name": "Jayanti Reddy Zardosi Bridal Lehenga", "price": 289000 },
  { "name": "Amit Aggarwal Metallic Sculpted Gown", "price": 377000 },

  { "name": "Paulmi & Harsh Floral Bridesmaid Lehenga", "price": 238000 },
  { "name": "Mahima Mahajan Organza Bridesmaid Set", "price": 168200 },
  { "name": "Ridhi Mehra Romantic Bridesmaid Gown", "price": 72000 },
  { "name": "Aisha Rao Maximalist Motif Lehenga", "price": 98000 },
  { "name": "Payal Singhal Printed Cape Set", "price": 62000 },
  { "name": "Arpita Mehta Garden Print Dress", "price": 58000 },
  { "name": "Mishru Floral Embroidered Lehenga", "price": 69000 },
  { "name": "Torani Vermillion Bridal Lehenga", "price": 215000 },
  { "name": "Ritika Mirchandani Pastel Lehenga", "price": 88000 },
  { "name": "Varun Bahl 3D Embroidered Cape Gown", "price": 92000 },

  { "name": "Manyavar Regal Sherwani Set", "price": 18999 },
  { "name": "Mohey Bridal Saree Ensemble", "price": 24999 },
  { "name": "Mebaz Designer Tuxedo Set", "price": 28999 },
  { "name": "Wedding Lace Mermaid Gown", "price": 18500 },
  { "name": "GownLink Ball Gown with Train", "price": 22999 },
  { "name": "GownLink Cathedral Veil", "price": 4999 },
  { "name": "GownLink Satin Opera Gloves", "price": 2999 },
  { "name": "GownLink Crown Tiara Set", "price": 3999 },
  { "name": "Wedding Lace Accessories Combo", "price": 5999 },
  { "name": "Wedding Lace Baptism Dress", "price": 3499 },

  { "name": "Indya Traditional Bridesmaid Lehenga", "price": 4999 },
  { "name": "Indya Floral Bridesmaid Dress", "price": 3999 },
  { "name": "Indya Sequin Bridesmaid Gown", "price": 5999 },
  { "name": "Indya Printed Kurta Set", "price": 2999 },
  { "name": "Indya Mirror Work Sharara", "price": 3499 },
  { "name": "Indya Pastel Lehenga", "price": 4500 },
  { "name": "Indya Crop Top Set", "price": 3800 },
  { "name": "Indya Reception Gown", "price": 6200 },
  { "name": "Indya Haldi Kurta Set", "price": 2800 },
  { "name": "Indya Mehendi Lehenga", "price": 3200 },

  { "name": "Myntra Boohoo Chiffon Dress", "price": 4224 },
  { "name": "Myntra Berrylush Floral Dress", "price": 779 },
  { "name": "Myntra Athena Cut-Out Dress", "price": 674 },
  { "name": "Myntra Style Quotient Puff Dress", "price": 400 },
  { "name": "Myntra DODO & MOA Flutter Dress", "price": 988 },
  { "name": "Myntra U&F Bustier Dress", "price": 781 },
  { "name": "Myntra PANIT Ethnic Dress", "price": 2589 },
  { "name": "Myntra emeros Maxi Dress", "price": 979 },
  { "name": "Myntra Boohoo Pleated Midi Dress", "price": 1674 },
  { "name": "Myntra plusS Volume Play Dress", "price": 459 },

  { "name": "Amazon Zeel Heavy Embroidered Lehenga", "price": 3229 },
  { "name": "Amazon TRENDMALLS Satin Lehenga", "price": 2949 },
  { "name": "Amazon Monrav Silk Lehenga", "price": 2000 },
  { "name": "Amazon Divine Exim Net Lehenga", "price": 5599 },
  { "name": "Amazon Zeel Sequins Net Lehenga", "price": 4274 },
  { "name": "Amazon Omkar Tex Bridal Lehenga", "price": 2989 },
  { "name": "Amazon VARNI FABRICS Net Lehenga", "price": 2349 },
  { "name": "Amazon Zeel Raw Silk Lehenga", "price": 3399 },
  { "name": "Amazon Zeel Organza Floral Lehenga", "price": 3229 },
  { "name": "Amazon Zeel Threads Sequins Lehenga", "price": 4274 },


  { "name": "Varun Bahl Ivory Embroidered Bridal Lehenga", "price": 295000 },
  { "name": "Rohit Bal Velvet Zardozi Lehenga", "price": 385000 },
  { "name": "JJ Valaya Royal Red Bridal Gown", "price": 425000 },
  { "name": "Neeta Lulla Gold Tissue Lehenga", "price": 265000 },
  { "name": "Reynu Taandon Mirror Work Bridal Lehenga", "price": 215000 },
  { "name": "KALKI Fashion Sequin Trail Gown", "price": 89000 },
  { "name": "Chhabra 555 Emerald Green Bridal Lehenga", "price": 54000 },
  { "name": "Ensemble Gopi Vaid Mirror & Gota Lehenga", "price": 145000 },
  { "name": "Mahima Mahajan Mustard Organza Lehenga", "price": 87000 },
  { "name": "Amit Aggarwal Blue Butterfly Net Lehenga", "price": 310000 },

  { "name": "House of Indya Bridesmaid Floral Lehenga", "price": 4999 },
  { "name": "Indya Mirror Work Bridesmaid Sharara", "price": 3499 },
  { "name": "Indya Reception Gown – Wine", "price": 6200 },
  { "name": "Indya Haldi Kurta Set – Yellow", "price": 2800 },
  { "name": "Indya Mehendi Lehenga – Green", "price": 3200 },
  { "name": "Indya Indo-Western Crop Top Set", "price": 3800 },
  { "name": "Indya Printed Kurta Set", "price": 2999 },
  { "name": "Indya Sequin Bridesmaid Gown", "price": 5999 },
  { "name": "Indya Pastel Bridesmaid Lehenga", "price": 4500 },
  { "name": "Indya Traditional Bridesmaid Lehenga", "price": 4999 },

  { "name": "Myntra Boohoo Chiffon Bridesmaid Dress", "price": 4224 },
  { "name": "Myntra Berrylush Romantic Florals Dress", "price": 779 },
  { "name": "Myntra Athena Solid Cut-Out Dress", "price": 674 },
  { "name": "Myntra Style Quotient Puff Sleeves Dress", "price": 400 },
  { "name": "Myntra DODO & MOA Flutter Sleeves Dress", "price": 988 },
  { "name": "Myntra PANIT Ethnic Spaghetti Dress", "price": 2589 },
  { "name": "Myntra emeros Crepe Maxi Dress", "price": 979 },
  { "name": "Myntra Boohoo Pleated Midi Bridesmaid Dress", "price": 1674 },
  { "name": "Myntra plusS Floral Volume Play Dress", "price": 459 },
  { "name": "Myntra U&F Bustier Bridesmaid Dress", "price": 781 },

  { "name": "GownLink Mermaid Wedding Gown", "price": 18500 },
  { "name": "GownLink Ball Gown with Train", "price": 22999 },
  { "name": "GownLink Cathedral Veil", "price": 4999 },
  { "name": "GownLink Satin Opera Gloves", "price": 2999 },
  { "name": "GownLink Crown Tiara Set", "price": 3999 },
  { "name": "GownLink Baptism Dress", "price": 3499 },
  { "name": "Wedding Lace A-Line Bridal Gown", "price": 21500 },
  { "name": "Wedding Lace Trumpet Gown", "price": 18900 },
  { "name": "Wedding Lace Bridal Accessories Combo", "price": 5999 },
  { "name": "Wedding Lace Veil & Gloves Set", "price": 4999 },

  { "name": "Amazon Zeel Clothing Heavy Embroidered Lehenga", "price": 3229 },
  { "name": "Amazon TRENDMALLS Satin Embroidery Lehenga", "price": 2949 },
  { "name": "Amazon Monrav Silk Semi-Stitched Lehenga", "price": 2000 },
  { "name": "Amazon Divine Exim Net Embroidered Lehenga", "price": 5599 },
  { "name": "Amazon Omkar Tex Bridal Lehenga", "price": 2989 },
  { "name": "Amazon VARNI FABRICS Net Embroidered Lehenga", "price": 2349 },
  { "name": "Amazon Zeel Clothing Raw Silk Lehenga", "price": 3399 },
  { "name": "Amazon Zeel Clothing Organza Floral Lehenga", "price": 3229 },
  { "name": "Amazon Zeel Clothing Threads Sequins Lehenga", "price": 4274 },
  { "name": "Amazon Zeel Clothing Pink Silk Bridal Lehenga", "price": 3514 },

  { "name": "Manyavar Classic Sherwani Set", "price": 18999 },
  { "name": "Mohey Bridal Saree Ensemble", "price": 24999 },
  { "name": "Mebaz Designer Tuxedo Set", "price": 28999 },
  { "name": "Samiva Bridal Lehenga – Tirupati Exclusive", "price": 18500 },
  { "name": "Siri Dress Divine Designer Lehenga", "price": 21500 },

  { "name": "JJ Valaya Ivory Zardozi Bridal Lehenga", "price": 445000 },
  { "name": "Rohit Bal Crimson Velvet Lehenga", "price": 385000 },
  { "name": "Neeta Lulla Gold Tissue Bridal Gown", "price": 265000 },
  { "name": "Reynu Taandon Mirror Embellished Lehenga", "price": 215000 },
  { "name": "Gaurav Gupta Sculpted Trail Gown", "price": 325000 },
  { "name": "KALKI Fashion Regal Red Bridal Lehenga", "price": 89000 },
  { "name": "Chhabra 555 Mustard Yellow Lehenga Set", "price": 54000 },
  { "name": "Ensemble Gopi Vaid Lime Mirror Lehenga", "price": 145000 },
  { "name": "Mahima Mahajan Yellow Organza Lehenga", "price": 87000 },
  { "name": "Amit Aggarwal Black Satin Cape Skirt Set", "price": 74800 },

  { "name": "House of Indya Bridesmaid Mirror Kurta Set", "price": 3499 },
  { "name": "Indya Reception Gown – Blush Pink", "price": 6200 },
  { "name": "Indya Haldi Kurta Set – Mustard", "price": 2800 },
  { "name": "Indya Mehendi Lehenga – Olive Green", "price": 3200 },
  { "name": "Indya Crop Top & Skirt Set – Coral", "price": 3800 },
  { "name": "Indya Sequin Bridesmaid Gown – Navy", "price": 5999 },
  { "name": "Indya Pastel Bridesmaid Lehenga – Mint", "price": 4500 },
  { "name": "Indya Traditional Bridesmaid Lehenga – Maroon", "price": 4999 },
  { "name": "Indya Printed Kurta Set – Peach", "price": 2999 },
  { "name": "Indya Floral Bridesmaid Dress – Lavender", "price": 3999 },

  { "name": "Myntra Boohoo Chiffon Bridesmaid Dress – Mauve", "price": 4224 },
  { "name": "Myntra Berrylush Floral Maxi Dress", "price": 779 },
  { "name": "Myntra Athena Cut-Out Bridesmaid Dress", "price": 674 },
  { "name": "Myntra Style Quotient Puff Sleeve Dress", "price": 400 },
  { "name": "Myntra DODO & MOA Flutter Dress – Pink", "price": 988 },
  { "name": "Myntra PANIT Ethnic Spaghetti Dress – Teal", "price": 2589 },
  { "name": "Myntra emeros Crepe Maxi Dress – Wine", "price": 979 },
  { "name": "Myntra Boohoo Pleated Midi Dress – Beige", "price": 1674 },
  { "name": "Myntra plusS Volume Play Dress – Floral", "price": 459 },
  { "name": "Myntra U&F Bustier Bridesmaid Dress – Black", "price": 781 },

  { "name": "GownLink Mermaid Wedding Gown – Lace", "price": 18500 },
  { "name": "GownLink Ball Gown with Train – Satin", "price": 22999 },
  { "name": "GownLink Cathedral Veil – Tulle", "price": 4999 },
  { "name": "GownLink Satin Opera Gloves – Ivory", "price": 2999 },
  { "name": "GownLink Crown Tiara Set – Crystal", "price": 3999 },
  { "name": "GownLink Baptism Dress – White", "price": 3499 },
  { "name": "Wedding Lace A-Line Bridal Gown – Organza", "price": 21500 },
  { "name": "Wedding Lace Trumpet Gown – Lace", "price": 18900 },
  { "name": "Wedding Lace Accessories Combo – Veil & Gloves", "price": 5999 },
  { "name": "Wedding Lace Bridal Tiara – Silver", "price": 4999 },

  { "name": "Amazon Zeel Clothing Pink Silk Bridal Lehenga", "price": 3514 },
  { "name": "Amazon TRENDMALLS Satin Embroidery Lehenga", "price": 2949 },
  { "name": "Amazon Monrav Silk Semi-Stitched Lehenga", "price": 2000 },
  { "name": "Amazon Divine Exim Net Embroidered Lehenga", "price": 5599 },
  { "name": "Amazon Omkar Tex Bridal Lehenga – Peach", "price": 2989 },
  { "name": "Amazon VARNI FABRICS Net Embroidered Lehenga", "price": 2349 },
  { "name": "Amazon Zeel Clothing Raw Silk Lehenga – Navy", "price": 3399 },
  { "name": "Amazon Zeel Clothing Organza Floral Lehenga – White", "price": 3229 },
  { "name": "Amazon Zeel Clothing Threads Sequins Lehenga – Brown", "price": 4274 },
  { "name": "Amazon Zeel Clothing Georgette Bridal Lehenga – Pink", "price": 2279 },
  { "name": "Manyavar Classic Sherwani Set – Ivory", "price": 18999 },
  { "name": "Mohey Bridal Saree Ensemble – Red", "price": 24999 },
  { "name": "Mebaz Designer Tuxedo Set – Black", "price": 28999 },
  { "name": "Samiva Bridal Lehenga – Tirupati Exclusive", "price": 18500 },
  { "name": "Siri Dress Divine Designer Lehenga – Coral", "price": 21500 },


                  ],
                  "Vintage & Concept Boutiques": [

      { "name": "Chanel Tweed Jacket 1980s", "price": 3200 },
  { "name": "YSL Tortoise Earrings 1970s", "price": 850 },
  { "name": "Christian Dior Logo Necklace", "price": 1200 },
  { "name": "Karl Lagerfeld Pearl Studs", "price": 950 },
  { "name": "Valentino Silk Blouse 1990s", "price": 780 },
  { "name": "Bodements Rococo Shirt", "price": 210 },
  { "name": "Red Empress 60s Style Jacket", "price": 340 },
  { "name": "The Local Vintage Olivia Cardigan", "price": 290 },
  { "name": "Viange Chanel Brooch", "price": 1100 },
  { "name": "No Borders 90s Skirt & Blouse Set", "price": 420 },
  { "name": "Carol’s Shop Floral Maxi Dress", "price": 180 },
  { "name": "Gucci Velvet Blazer 1970s", "price": 2500 },
  { "name": "Givenchy Gold Cuff 1980s", "price": 980 },
  { "name": "Celine Leather Handbag 1990s", "price": 1600 },
  { "name": "Bodements Quilted Kimono", "price": 390 },
  { "name": "Red Empress Printed Shirt", "price": 260 },
  { "name": "The Local Vintage 70s Blouse", "price": 230 },
  { "name": "Viange Dior Clip-On Earrings", "price": 870 },
  { "name": "No Borders Thandatti Earrings", "price": 150 },
  { "name": "Carol’s Shop Garden Rose Dress", "price": 200 },
  { "name": "Prada Retro Sunglasses", "price": 680 },
  { "name": "Versace Baroque Print Shirt", "price": 950 },
  { "name": "Moschino Heart Bag 1990s", "price": 720 },
  { "name": "Bodements Hand-Picked Blazer", "price": 310 },
  { "name": "Red Empress Funky Trousers", "price": 280 },
  { "name": "The Local Vintage 80s Dress", "price": 350 },
  { "name": "Viange Tiffany & Co. Pendant", "price": 1050 },
  { "name": "No Borders Patchwork Jacket", "price": 490 },
  { "name": "Carol’s Shop Boho Tunic", "price": 170 },
  { "name": "Dolce & Gabbana Leopard Coat", "price": 2900 },
  { "name": "Balmain Structured Blazer", "price": 2100 },
  { "name": "Hermès Silk Scarf 1970s", "price": 980 },
  { "name": "Bodements Upcycled Denim Jacket", "price": 330 },
  { "name": "Red Empress Retro Mini Skirt", "price": 240 },
  { "name": "The Local Vintage Gulnar Collection Dress", "price": 390 },
  { "name": "Viange Nina Ricci Earrings", "price": 790 },
  { "name": "No Borders Vintage Print Dress", "price": 410 },
  { "name": "Carol’s Shop Tea Party Skirt", "price": 160 },
  { "name": "Vivienne Westwood Corset Top", "price": 1100 },
  { "name": "Jean Paul Gaultier Mesh Shirt", "price": 980 },
  { "name": "Alexander McQueen Gothic Jacket", "price": 2700 },
  { "name": "Bodements Parisian Blouse", "price": 250 },
  { "name": "Red Empress Bold Print Blazer", "price": 360 },
  { "name": "The Local Vintage 90s Denim Dress", "price": 310 },
  { "name": "Viange Chanel Logo Earrings", "price": 1150 },
  { "name": "No Borders Artisan Wrap Dress", "price": 430 },
  { "name": "Carol’s Shop Vintage Tea Set", "price": 140 },
  { "name": "Fendi Retro Sunglasses", "price": 720 },
  { "name": "Burberry Trench Coat 1980s", "price": 1800 },
  { "name": "Bodements Italian Silk Shirt", "price": 290 },
  { "name": "Red Empress Genderfluid Shirt", "price": 310 },
  { "name": "The Local Vintage 60s Maxi Dress", "price": 370 },
  { "name": "Viange Chanel Pearl Necklace", "price": 1350 },
  { "name": "No Borders Bohemian Cape", "price": 460 },
  { "name": "Carol’s Shop Retro Sunglasses", "price": 150 },
  { "name": "Marc Jacobs 90s Slip Dress", "price": 880 },
  { "name": "Tom Ford Velvet Pants", "price": 950 },
  { "name": "Bodements French Military Jacket", "price": 410 },
  { "name": "Red Empress Printed Palazzo", "price": 270 },
  { "name": "The Local Vintage 70s Tunic", "price": 290 },
  { "name": "Viange Christian Dior Brooch", "price": 990 },
  { "name": "No Borders Vintage Sari Fusion", "price": 520 },
  { "name": "Carol’s Shop Patchwork Dress", "price": 190 },
  { "name": "Lanvin Retro Clutch", "price": 780 },
  { "name": "Stella McCartney Vintage Coat", "price": 1650 },
  { "name": "Bodements Upcycled Patch Jacket", "price": 350 },
  { "name": "Red Empress 80s Power Blazer", "price": 390 },
  { "name": "The Local Vintage 90s Crop Top", "price": 210 },
  { "name": "Viange Chanel Chain Belt", "price": 1250 },
  { "name": "No Borders Vintage Fusion Pants", "price": 440 },
  { "name": "Carol’s Shop Retro Print Shirt", "price": 180 },


  { "name": "Chanel Sequin Blazer 1990s", "price": 3400 },
  { "name": "YSL Velvet Maxi Dress", "price": 1800 },
  { "name": "Christian Lacroix Statement Earrings", "price": 980 },
  { "name": "Vivienne Westwood Orb Necklace", "price": 1250 },
  { "name": "Versace Medusa Print Pants", "price": 890 },
  { "name": "Bodements Retro Patchwork Shirt", "price": 310 },
  { "name": "Red Empress Psychedelic Blouse", "price": 270 },
  { "name": "The Local Vintage 80s Windbreaker", "price": 330 },
  { "name": "Viange Givenchy Clip Earrings", "price": 920 },
  { "name": "No Borders Handloom Fusion Dress", "price": 480 },
  { "name": "Carol’s Shop Vintage Kimono", "price": 210 },
  { "name": "Gucci 70s Floral Maxi Dress", "price": 2600 },
  { "name": "Balenciaga Structured Coat", "price": 2900 },
  { "name": "Celine Retro Sunglasses", "price": 720 },
  { "name": "Bodements Vintage Military Shirt", "price": 350 },
  { "name": "Red Empress 90s Denim Jacket", "price": 310 },
  { "name": "The Local Vintage Parisian Blazer", "price": 390 },
  { "name": "Viange Tiffany & Co. Brooch", "price": 980 },
  { "name": "No Borders Artisan Tunic", "price": 430 },
  { "name": "Carol’s Shop Retro Tea Dress", "price": 190 },
  { "name": "Dolce & Gabbana 80s Power Suit", "price": 3100 },
  { "name": "Tom Ford Cropped Jacket", "price": 1200 },
  { "name": "Hermès Vintage Leather Gloves", "price": 650 },
  { "name": "Bodements Upcycled Silk Blazer", "price": 370 },
  { "name": "Red Empress Printed Kaftan", "price": 290 },
  { "name": "The Local Vintage 70s Jumpsuit", "price": 410 },
  { "name": "Viange Nina Ricci Pendant", "price": 870 },
  { "name": "No Borders Vintage Fusion Saree", "price": 540 },
  { "name": "Carol’s Shop Bohemian Wrap", "price": 180 },
  { "name": "Prada Retro Leather Skirt", "price": 980 },
  { "name": "Fendi 90s Shoulder Bag", "price": 1650 },
  { "name": "Alexander McQueen Lace Blouse", "price": 1450 },
  { "name": "Bodements Vintage Denim Overalls", "price": 330 },
  { "name": "Red Empress Funky Blazer", "price": 360 },
  { "name": "The Local Vintage 60s Shift Dress", "price": 370 },
  { "name": "Viange Dior Gold Cuff", "price": 990 },
  { "name": "No Borders Patchwork Fusion Coat", "price": 490 },
  { "name": "Carol’s Shop Retro Print Tunic", "price": 160 },
  { "name": "Marc Jacobs Vintage Slip Top", "price": 780 },
  { "name": "Jean Paul Gaultier Mesh Dress", "price": 1100 },
  { "name": "Stella McCartney Vintage Blazer", "price": 1750 },
  { "name": "Bodements Rococo Inspired Coat", "price": 410 },
  { "name": "Red Empress 70s Palazzo Pants", "price": 270 },
  { "name": "The Local Vintage 90s Crop Blouse", "price": 230 },
  { "name": "Viange Chanel Crystal Earrings", "price": 1150 },
  { "name": "No Borders Vintage Fusion Tunic", "price": 460 },
  { "name": "Carol’s Shop Retro Maxi Skirt", "price": 170 },
  { "name": "Lanvin Vintage Clutch", "price": 820 },
  { "name": "Burberry 80s Trench Dress", "price": 1900 },
  { "name": "Bodements Upcycled Patch Blazer", "price": 390 },
  { "name": "Red Empress Bold Print Shirt", "price": 310 },
  { "name": "The Local Vintage 70s Wrap Dress", "price": 350 },
  { "name": "Viange Christian Dior Chain Belt", "price": 1250 },
  { "name": "No Borders Vintage Fusion Blazer", "price": 470 },
  { "name": "Carol’s Shop Retro Floral Dress", "price": 200 },
  { "name": "Valentino 90s Silk Blouse", "price": 880 },
  { "name": "Moschino Heart Print Jacket", "price": 980 },
  { "name": "Bodements Parisian Tunic", "price": 290 },
  { "name": "Red Empress Printed Midi Dress", "price": 330 },
  { "name": "The Local Vintage 80s Denim Skirt", "price": 310 },
  { "name": "Viange Chanel Logo Brooch", "price": 1350 },
  { "name": "No Borders Handloom Fusion Pants", "price": 440 },
  { "name": "Carol’s Shop Vintage Tea Blouse", "price": 150 },
  { "name": "YSL Retro Sunglasses", "price": 720 },
  { "name": "Balmain Vintage Power Blazer", "price": 2100 },
  { "name": "Bodements Upcycled Denim Shirt", "price": 330 },
  { "name": "Red Empress Genderfluid Tunic", "price": 310 },
  { "name": "The Local Vintage 60s Maxi Skirt", "price": 370 },
  { "name": "Viange Chanel Pearl Earrings", "price": 1350 },
  { "name": "No Borders Bohemian Fusion Dress", "price": 520 },
  { "name": "Carol’s Shop Patchwork Tunic", "price": 190 },


  { "name": "Chanel Tweed Cape 1980s", "price": 3500 },
  { "name": "YSL Silk Ruffle Blouse", "price": 1600 },
  { "name": "Christian Dior 70s Maxi Dress", "price": 2800 },
  { "name": "Vivienne Westwood Tartan Corset", "price": 1250 },
  { "name": "Versace Vintage Denim Jacket", "price": 980 },
  { "name": "Bodements Upcycled Velvet Blazer", "price": 370 },
  { "name": "Red Empress Psychedelic Maxi Dress", "price": 310 },
  { "name": "The Local Vintage 80s Knit Dress", "price": 290 },
  { "name": "Viange Givenchy Gold Pendant", "price": 950 },
  { "name": "No Borders Handloom Fusion Skirt", "price": 480 },
  { "name": "Carol’s Shop Vintage Patch Blouse", "price": 180 },
  { "name": "Gucci 70s Leather Trench", "price": 2700 },
  { "name": "Balenciaga Retro Wool Blazer", "price": 2500 },
  { "name": "Celine Vintage Silk Shirt", "price": 1650 },
  { "name": "Bodements Rococo Print Blazer", "price": 390 },
  { "name": "Red Empress Funky Print Pants", "price": 280 },
  { "name": "The Local Vintage 90s Crop Jacket", "price": 310 },
  { "name": "Viange Tiffany & Co. Chain Necklace", "price": 980 },
  { "name": "No Borders Artisan Wrap Skirt", "price": 430 },
  { "name": "Carol’s Shop Retro Tea Blouse", "price": 160 },
  { "name": "Dolce & Gabbana Vintage Print Dress", "price": 2900 },
  { "name": "Tom Ford 80s Sunglasses", "price": 880 },
  { "name": "Hermès Vintage Silk Blouse", "price": 720 },
  { "name": "Bodements Upcycled Denim Coat", "price": 410 },
  { "name": "Red Empress Printed Kaftan Dress", "price": 330 },
  { "name": "The Local Vintage 70s Palazzo Pants", "price": 370 },
  { "name": "Viange Nina Ricci Crystal Earrings", "price": 870 },
  { "name": "No Borders Patchwork Fusion Tunic", "price": 490 },
  { "name": "Carol’s Shop Vintage Maxi Skirt", "price": 190 },
  { "name": "Prada Retro Leather Handbag", "price": 2200 },
  { "name": "Fendi 90s Print Blouse", "price": 1650 },
  { "name": "Alexander McQueen Gothic Print Dress", "price": 1450 },
  { "name": "Bodements Parisian Wrap Dress", "price": 330 },
  { "name": "Red Empress 80s Style Blazer", "price": 360 },
  { "name": "The Local Vintage 60s Tunic", "price": 290 },
  { "name": "Viange Dior Logo Brooch", "price": 990 },
  { "name": "No Borders Handloom Fusion Jacket", "price": 520 },
  { "name": "Carol’s Shop Retro Print Dress", "price": 200 },
  { "name": "Marc Jacobs Vintage Slip Skirt", "price": 780 },
  { "name": "Jean Paul Gaultier Mesh Blouse", "price": 980 },
  { "name": "Stella McCartney Vintage Blazer", "price": 1750 },
  { "name": "Bodements Upcycled Patch Coat", "price": 410 },
  { "name": "Red Empress Printed Midi Tunic", "price": 310 },
  { "name": "The Local Vintage 90s Denim Skirt", "price": 330 },
  { "name": "Viange Chanel Crystal Brooch", "price": 1350 },
  { "name": "No Borders Bohemian Fusion Wrap", "price": 490 },
  { "name": "Carol’s Shop Patchwork Tunic", "price": 180 },
  { "name": "Lanvin Vintage Shoulder Bag", "price": 820 },
  { "name": "Burberry 80s Wool Coat", "price": 1900 },
  { "name": "Bodements Upcycled Silk Shirt", "price": 330 },
  { "name": "Red Empress Genderfluid Maxi Dress", "price": 310 },
  { "name": "The Local Vintage 70s Crop Top", "price": 230 },
  { "name": "Viange Christian Dior Pearl Earrings", "price": 990 },
  { "name": "No Borders Handloom Fusion Blazer", "price": 470 },
  { "name": "Carol’s Shop Vintage Tea Wrap", "price": 150 },
  { "name": "YSL Retro Print Blazer", "price": 720 },
  { "name": "Balmain Vintage Power Coat", "price": 2100 },
  { "name": "Bodements Upcycled Denim Tunic", "price": 330 },
  { "name": "Red Empress Printed Palazzo Skirt", "price": 310 },
  { "name": "The Local Vintage 80s Maxi Skirt", "price": 370 },
  { "name": "Viange Chanel Logo Necklace", "price": 1350 },
  { "name": "No Borders Bohemian Fusion Pants", "price": 520 },
  { "name": "Carol’s Shop Patchwork Wrap Skirt", "price": 190 },
  { "name": "Valentino 90s Silk Tunic", "price": 880 },
  { "name": "Moschino Heart Print Blazer", "price": 980 },
  { "name": "Bodements Parisian Maxi Dress", "price": 290 },
  { "name": "Red Empress Printed Midi Blouse", "price": 330 },
  { "name": "The Local Vintage 60s Crop Blouse", "price": 230 },
  { "name": "Viange Christian Dior Crystal Pendant", "price": 990 },
  { "name": "No Borders Handloom Fusion Wrap", "price": 460 },
  { "name": "Carol’s Shop Vintage Tea Dress", "price": 150 },


                  ],
                  "Others": [

      { "name": "other items", "price": 1990 },
  { "name": "Custom boutique item", "price": 3460 },
  { "name": "additional item", "price": 1150 },

                  ],
                 

   
  });

  const [searchText, setSearchText] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  


  const [shopName, setShopName] = useState('');
  const [gstNumber, setGstNumber] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedItem, setSelectedItem] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [cart, setCart] = useState([]);
  const [gstRate, setGstRate] = useState(0);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [showModal, setShowModal] = useState(false);

  const [shareMethod, setShareMethod] = useState('');
  const [pdfFormat, setPdfFormat] = useState('default');


  const handleSearchChange = (event) => {
    const text = event.target.value;
    setSearchText(text);
  
    const allItems = Object.entries(categories).flatMap(([category, items]) =>
      items.map(item => ({ ...item, category }))
    );
  
    const filtered = allItems.filter(item =>
      item.name.toLowerCase().includes(text.toLowerCase())
    );
  
    setSuggestions(filtered);
  };

  const handleSelectSuggestion = (item) => {
    const newItem = {
      name: item.name,
      price: item.price,
      quantity: 1,
      subtotal: item.price * 1,
    };
    setCart([...cart, newItem]);
    setSearchText('');
    setSuggestions([]);
  };

  const handleNewBill = () => {
    setShopName('');
    setGstNumber('');
    setPhoneNumber('');
    setSelectedCategory('');
    setSelectedItem('');
    setQuantity(1);
    setCart([]);
    setGstRate(0);
    setSearchText('');
    setSuggestions([]);
    setPdfFormat('default');
  };
  

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
    setSelectedItem('');
    setQuantity(1);
  };

  const handleItemChange = (event) => {
    setSelectedItem(event.target.value);
    setQuantity(1);
  };

  const handleQuantityChange = (event) => {
    setQuantity(event.target.value);
  };

  const handleAddItem = () => {
    const categoryItems = categories[selectedCategory];
    const item = categoryItems.find(i => i.name === selectedItem);
    if (item) {
      const newItem = {
        name: item.name,
        price: item.price,
        quantity: quantity,
        subtotal: item.price * quantity
      };
      setCart([...cart, newItem]);
      setSelectedItem('');
      setQuantity(1);
    }
  };

  const handleGstRateChange = (event) => {
    setGstRate(event.target.value);
  };

  const handlePriceChange = (index, event) => {
    const newCart = [...cart];
    newCart[index].price = event.target.value;
    newCart[index].subtotal = newCart[index].price * newCart[index].quantity;
    setCart(newCart);
  };

  const handleQuantityEdit = (index, event) => {
    const newCart = [...cart];
    newCart[index].quantity = event.target.value;
    newCart[index].subtotal = newCart[index].price * newCart[index].quantity;
    setCart(newCart);
  };

  const handleRemoveItem = (index) => {
    const newCart = [...cart];
    newCart.splice(index, 1); // Remove one item at the given index
    setCart(newCart);
  };
  
  const calculateTotal = () => {
    const subtotal = cart.reduce((acc, item) => acc + item.subtotal, 0);
    const gst = subtotal * (gstRate / 100);
    const total = subtotal + gst;
    return { subtotal, gst, total };
  };

  const generatePdfInvoice = () => {
    const total = calculateTotal();
    const currentDate = new Date().toLocaleDateString();
    const doc = new jsPDF();

    switch (pdfFormat) {
        case 'default':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

        case 'table':
            doc.autoTable({
                head: [[' Name', 'GST No', 'Phone Number', 'Date']],
                body: [[shopName, gstNumber, phoneNumber, currentDate]],
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                head: [['Item No', 'Item', 'Price', 'Quantity(Kg/Ltr/each)', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

        case 'blueBlack':
            doc.setTextColor(0, 0, 255);
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.setTextColor(0, 0, 0);
            doc.autoTable({
                startY: 40,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

        case 'professionalGrid':
            doc.setFontSize(18);
            doc.text(shopName, 10, 10);
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 10, 20);
            doc.text(`Date: ${currentDate}`, 10, 30);
            doc.autoTable({
                startY: 40,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
                theme: 'grid',
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
                theme: 'grid',
            });
            break;

        case 'compactSummary':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item', 'Quantity', 'Subtotal']],
                body: cart.map((item) => [item.name, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

            
                case 'classicTable':
                    doc.setFontSize(20);
                    doc.text(shopName, 105, 15, null, null, 'center');
                    doc.setFontSize(12);
                    doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
                    doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
                    doc.setFontSize(16);
                    doc.text('Invoice', 105, 30, null, null, 'center');
                    doc.autoTable({
                        startY: 40,
                        head: [['Item No', 'Item', 'Price', 'Quantity(Kg/Ltr/each)', 'Subtotal']],
                        body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
                    });
                    doc.autoTable({
                        startY: doc.lastAutoTable.finalY + 10,
                        body: [
                            ['Subtotal', total.subtotal.toFixed(2)],
                            ['GST', total.gst.toFixed(2)],
                            ['Total', total.total.toFixed(2)],
                        ],
                    });
                    break;
        
                case 'boxedLayout':
                    doc.setFontSize(20);
                    doc.text(shopName, 10, 10);
                    doc.setFontSize(12);
                    doc.text(`GST No: ${gstNumber}`, 10, 20);
                    doc.text(`Date: ${currentDate}`, 10, 30);
                    doc.autoTable({
                        startY: 40,
                        head: [['Item', 'Price', 'Quantity', 'Subtotal']],
                        body: cart.map((item) => [item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
                        styles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0], lineWidth: 0.5 },
                    });
                    doc.autoTable({
                        startY: doc.lastAutoTable.finalY + 10,
                        body: [
                            ['Subtotal', total.subtotal.toFixed(2)],
                            ['GST', total.gst.toFixed(2)],
                            ['Total', total.total.toFixed(2)],
                        ],
                        styles: { fillColor: [0, 180, 0], textColor: [0, 0, 0] },
                    });
            break;   
            
            

        case 'modernMinimalist':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item', 'Quantity(Kg/ltr/each', 'Subtotal']],
                body: cart.map((item) => [item.name, item.quantity, item.subtotal.toFixed(2)]),
                styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.1 },
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
                styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.1 },
            });
            break;

        case 'elegantLines':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item', 'Quantity', 'Subtotal']],
                body: cart.map((item) => [item.name, item.quantity, item.subtotal.toFixed(2)]),
                styles: { fontStyle: 'italic', fontSize: 12, lineColor: [150, 150, 150], lineWidth: 0.1 },
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
                styles: { fontStyle: 'italic', fontSize: 12, lineColor: [150, 150, 150], lineWidth: 0.1 },
            });
            break;

        case 'detailedSections':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Section', 'Details']],
                body: [
                    ['Shop Details', `${shopName}, GST No: ${gstNumber}, Date: ${currentDate}`],
                    ['Items', cart.map((item) => `Name: ${item.name}, Quantity: ${item.quantity}, Subtotal: ${item.subtotal.toFixed(2)}`).join('; ')],
                    ['Totals', `Subtotal: ${total.subtotal.toFixed(2)}, GST: ${total.gst.toFixed(2)}, Total: ${total.total.toFixed(2)}`],
                ],
                styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.5 },
            });
            break;

        

        default:
            break;
    }

    // Save the PDF to Blob
    const pdfBlob = doc.output('blob');

    // Share to WhatsApp
    const shareToWhatsApp = () => {
        const fileURL = URL.createObjectURL(pdfBlob);
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=Your invoice is ready. Download it here: ${fileURL}`;
        window.open(whatsappUrl, '_blank');
    };

    // Share to Email
    const shareToEmail = () => {
        const fileURL = URL.createObjectURL(pdfBlob);
        const mailtoUrl = `mailto:?subject=Your Invoice&body=Your invoice is ready. Download it here: ${fileURL}`;
        window.open(mailtoUrl, '_blank');
    };

    // Share the PDF as needed
    if (shareMethod === 'whatsapp') {
        shareToWhatsApp();
    } else if (shareMethod === 'mail') {
        shareToEmail();
    }

    // Save the PDF
    //doc.save('invoice.pdf');
    doc.save(`${shopName +'-invoice' || 'invoice'}.pdf`);

};


  const handleShare = (method) => {
    setShareMethod(method); // Set the sharing method
    const shareText = `Shop Name: ${shopName}\nGST No: ${gstNumber}\nPhone Number: ${phoneNumber}`;

    if (method === 'whatsapp') {
      window.open(`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(shareText)}`);
    } else if (method === 'mail') {
      window.open(`mailto:?subject=MarketApp%20Details&body=${encodeURIComponent(shareText)}`);
    }

    setShowModal(false); // Close modal after sharing
  };

  const handleGenerateAndShare = () => {
    generatePdfInvoice();
    setShowModal(true); // Show modal after generating PDF
  };

  const handleFormatChange = (e) => {
    setPdfFormat(e.target.value); // Set the PDF format
};

const formatOptions = [
    { value: 'default', label: 'Default' },
    { value: 'table', label: 'Table Format' },
    { value: 'blueBlack', label: 'Blue and Black' },
    { value: 'professionalGrid', label: 'Professional Grid' },
    { value: 'compactSummary', label: 'Compact Summary' },
    { value: 'classicTable', label: 'Classic Table' },
    { value: 'boxedLayout', label: 'Boxed Layout' },
    { value: 'modernMinimalist', label: 'Modern Minimalist' },
    { value: 'elegantLines', label: 'Elegant Lines' },
    { value: 'detailedSections', label: 'Detailed Sections' },
    
];


return (
    <div className="MarketApp">
      <img src="./Images/jalm.png" alt="Just A Little Market" width="100" height="100" />
      <h1><u>Boutique Store</u></h1>

<div style={{ marginTop: '20px', textAlign: 'left', paddingLeft: '10px' }}>
  <button
    onClick={handleNewBill}
    style={{
      backgroundColor: '#007bff',
      color: '#fff',
      padding: '12px 20px',
      fontSize: '18px',
      fontWeight: '600',
      border: 'none',
      cursor: 'pointer',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 123, 255, 0.3)',
      transition: 'background-color 0.3s ease, transform 0.2s ease'
    }}
    onMouseOver={(e) => {
      e.target.style.backgroundColor = '#0056b3';
      e.target.style.transform = 'scale(1.05)';
    }}
    onMouseOut={(e) => {
      e.target.style.backgroundColor = '#007bff';
      e.target.style.transform = 'scale(1)';
    }}
  >
    🧾 New Bill
  </button>
</div>
<br/>

  
      {/* Shop Info */}
  
    <div className="container">
  {/* Responsive Input Section */}
  <div className="input-section">
    <div className="form-group">
      <label>Boutique Name:</label>
      <input type="text" value={shopName} onChange={(e) => setShopName(e.target.value)} />
    </div>

    <div className="form-group">
      <label>GST No:</label>
      <input type="text" value={gstNumber} onChange={(e) => setGstNumber(e.target.value)} />
    </div>

    <div className="form-group">
      <label>Phone Number:</label>
      <input type="text" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
    </div>

    <div className="form-group">
      <label>Search Items:</label>
      <input
        type="text"
        value={searchText}
        onChange={handleSearchChange}
        placeholder="Type to search..."
      />
      {suggestions.length > 0 && (
        <ul className="suggestion-list">
          {suggestions.map((item, idx) => (
            <li key={idx} onClick={() => handleSelectSuggestion(item)}>
              {item.name} — ₹{item.price} <span className="category">({item.category})</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  </div>

  {/* Category Selection */}
  <div className="form-group">
    <label>Select Category:</label>
    <select onChange={handleCategoryChange} value={selectedCategory}>
      <option value="" disabled>Select a category</option>
      {Object.keys(categories).map((cat, i) => (
        <option key={i} value={cat}>{cat}</option>
      ))}
    </select>
  </div>

  {selectedCategory && (
    <>
      <div className="form-group">
        <label>Select Item:</label>
        <select onChange={handleItemChange} value={selectedItem}>
          <option value="" disabled>Select an item</option>
          {categories[selectedCategory].map((item, i) => (
            <option key={i} value={item.name}>{item.name}</option>
          ))}
        </select>
      </div>

      {selectedItem && (
        <>
          <div className="form-group">
            <label>Quantity:</label>
            <input type="number" value={quantity} onChange={handleQuantityChange} min="1" />
          </div>
          <div className="form-group">
            <button onClick={handleAddItem}>Add Item</button>
          </div>
        </>
      )}
    </>
  )}

  {/* Cart Table */}
  <div className="cart-section">
    <h2>Cart</h2>
    {cart.length === 0 ? (
      <p>No items added.</p>
    ) : (
      <div className="responsive-table">
        <table>
          <thead>
            <tr>
              <th>Item</th>
              <th>Price</th>
              <th>Qty</th>
              <th>Subtotal</th>
              <th>Remove</th>
            </tr>
          </thead>
          <tbody>
            {cart.map((item, index) => (
              <tr key={index}>
                <td>{item.name}</td>
                <td>
                  <input
                    type="number"
                    value={item.price}
                    onChange={(e) => handlePriceChange(index, e)}
                    min="0"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    value={item.quantity}
                    onChange={(e) => handleQuantityEdit(index, e)}
                    min="1"
                  />
                </td>
                <td>{item.subtotal.toFixed(2)}</td>
                <td><button onClick={() => handleRemoveItem(index)}>Remove</button></td>
              </tr>
            ))}
            <tr>
              <td colSpan="3">Subtotal</td>
              <td>{calculateTotal().subtotal.toFixed(2)}</td>
            </tr>
            <tr>
              <td colSpan="3">
                GST Rate:
                <select onChange={handleGstRateChange} value={gstRate}>
                  <option value="0">0%</option>
                  <option value="5">5%</option>
                  <option value="6">6%</option>
                  <option value="9">9%</option>
                  <option value="18">18%</option>
                </select>
              </td>
              <td>{calculateTotal().gst.toFixed(2)}</td>
            </tr>
            <tr>
              <td colSpan="3">Total</td>
              <td>{calculateTotal().total.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    )}
  </div>

  {/* PDF Section */}
{cart.length > 0 && (
 
  <div className="pdf-section" style={{
    marginTop: '30px',
    padding: '20px',
    backgroundColor: '#f1f3f5',
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  }}>
    <label style={{
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#333'
    }}>
      🧾 Select Invoice Format:
    </label>

    <select
      onChange={handleFormatChange}
      value={pdfFormat}
      style={{
        padding: '10px',
        fontSize: '16px',
        borderRadius: '6px',
        border: '1px solid #ccc',
        width: '100%',
        boxSizing: 'border-box'
      }}
    >
      {formatOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>

    <button
      onClick={handleGenerateAndShare}
      style={{
        backgroundColor: '#007bff',
        color: '#fff',
        padding: '14px',
        fontSize: '17px',
        fontWeight: '600',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        boxShadow: '0 4px 8px rgba(0,123,255,0.3)',
        transition: 'transform 0.2s ease, background-color 0.3s ease'
      }}
      onMouseOver={(e) => {
        e.target.style.backgroundColor = '#0056b3';
        e.target.style.transform = 'scale(1.05)';
      }}
      onMouseOut={(e) => {
        e.target.style.backgroundColor = '#007bff';
        e.target.style.transform = 'scale(1)';
      }}
    >
      📄 Generate PDF Invoice
    </button>
  </div>
)}


<br /><br />

 

</div>

 </div>   
  ); // ✅ this closes the return statement
  
  
}

export default Boutique;
  


  

